/* Deckaura Love Tarot translations.
   Exact, sentence-level translations replace the former word substitutions so
   each published locale remains grammatically complete. */
(function () {
  "use strict";

  var raw = String(
    (document.documentElement && document.documentElement.lang) || "en",
  ).toLowerCase();
  var lang =
    raw.indexOf("tr") === 0
      ? "tr"
      : raw.indexOf("de") === 0
        ? "de"
        : raw.indexOf("es") === 0
          ? "es"
          : raw.indexOf("pt") === 0
            ? "pt"
            : "en";

  var DATA = {
    tr: {
      ui: {
        "Three-card relationship spread": "Üç kartlık ilişki açılımı",
        "Free Love Tarot Reading": "Ücretsiz Aşk Tarotu Falı",
        "Ask one focused relationship question. Reveal three cards and receive an instant symbolic reading about the pattern, what you can observe and your grounded next step.":
          "İlişkinizle ilgili tek ve odaklı bir soru sorun. Üç kartı açın; örüntü, gözlemleyebileceğiniz işaretler ve sağlam bir sonraki adım hakkında anında sembolik bir yorum alın.",
        "Reveal My Free Love Reading": "Ücretsiz Aşk Yorumumu Aç",
        "3 cards": "3 kart",
        "Instant result": "Anında sonuç",
        "No sign-up": "Kayıt gerekmez",
        "Start over": "Baştan başla",
        "Today’s free three-card opening is complete.":
          "Bugünkü ücretsiz üç kart açılımınız tamamlandı.",
        "You can still shape a private personal reading from this focus and question. Your previous result remains available in the tab where you opened it.":
          "Bu odak ve sorudan kişisel, özel bir yorum oluşturmaya devam edebilirsiniz. Önceki sonucunuz açtığınız sekmede kalır.",
        "What do you want to understand?": "Neyi anlamak istiyorsunuz?",
        "Pick one focus. Your cards, your reading and your options all follow from it.":
          "Tek bir odak seçin. Kartlarınız, yorumunuz ve seçenekleriniz buna göre şekillenir.",
        "Where are things right now?": "Şu anda durumunuz nedir?",
        "This changes how the same three cards are read.":
          "Bu seçim aynı üç kartın nasıl yorumlanacağını değiştirir.",
        "What would you like to understand clearly?":
          "Neyi net biçimde anlamak istersiniz?",
        "Keep it to one relationship and one focused question.":
          "Tek bir ilişkiye ve tek bir odaklı soruya bağlı kalın.",
        "Your question": "Sorunuz",
        "Need a starting point?": "Başlangıç fikri ister misiniz?",
        "Open questions read more clearly than yes-or-no questions.":
          "Açık uçlu sorular, evet-hayır sorularından daha net yorumlanır.",
        "Write your question first — one sentence is enough.":
          "Önce sorunuzu yazın; tek cümle yeterlidir.",
        "Your three cards": "Üç kartınız",
        "← Back": "← Geri",
        "Your reading": "Yorumunuz",
        Focus: "Odak",
        Situation: "Durum",
        Question: "Soru",
        "Kept on this page during your session. No account, and nothing is shared.":
          "Oturumunuz boyunca yalnızca bu sayfada tutulur. Hesap gerekmez ve hiçbir şey paylaşılmaz.",
        "Your love reading": "Aşk yorumunuz",
        "Your reading leans toward": "Yorumunuzun eğilimi",
        "This is symbolic guidance, not proof of another person’s private thoughts.":
          "Bu sembolik bir rehberliktir; başka birinin özel düşüncelerinin kanıtı değildir.",
        "Question-specific synthesis": "Sorunuza özel sentez",
        "All three cards connected": "Üç kart birlikte yorumlandı",
        "Grounded, observable guidance": "Somut ve gözlemlenebilir rehberlik",
        "Your cards, read for your question":
          "Kartlarınız, sorunuza göre yorumlandı",
        "What the spread is showing": "Açılımın gösterdiği örüntü",
        "What you can do next": "Şimdi yapabilecekleriniz",
        "Why a personal reading is different": "Kişisel yorum neden farklıdır?",
        "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
          "Ücretsiz yorum kartların örüntüsünü gösterir. İsteğe bağlı, kişisel yazılı yorum aynı soru ve kartlarla belirleyici koşulu, farklı zamanlama olasılıklarını ve seçtiğiniz kapsamda uygulanabilir sonraki adımları inceler.",
        "Continue to reading options →": "Yorum seçeneklerine devam et →",
        "ONE FREE OPENING PER 24 HOURS": "24 SAATTE BİR ÜCRETSİZ AÇILIM",
        "Your next love question is still here.":
          "Yeni aşk sorunuz hâlâ burada.",
        "Today’s free three-card result has already been opened on this device. You can still take one useful symbolic cue from this question, or continue with a private personal reading.":
          "Bugünkü ücretsiz üç kart sonucu bu cihazda zaten açıldı. Bu sorudan yine de yararlı bir sembolik işaret alabilir veya özel kişisel yorumla devam edebilirsiniz.",
        "Today’s symbolic cue": "Bugünün sembolik işareti",
        "Your question stays in this tab and is only attached when you choose a reading.":
          "Sorunuz bu sekmede kalır ve yalnızca bir yorum seçtiğinizde siparişe eklenir.",
        "Your reading context": "Yorum bağlamınız",
        "Edit question": "Soruyu düzenle",
        Cards: "Kartlar",
        "Private spread": "Özel açılım",
        "Three cards reserved for your personal reading":
          "Kişisel yorumunuz için üç kart ayrıldı",
        "First insight now": "İlk içgörü ekranda",
        "Written by hand · most within 90 min":
          "Elle yazılır · çoğu 90 dakika içinde",
        "See full details": "Tüm ayrıntıları gör",
        "Private written reading":
          "Özel yazılı yorum",
        "Your question, situation and spread stay connected—no generic restart.":
          "Sorunuz, durumunuz ve açılımınız birlikte kalır; genel bir yorumla baştan başlanmaz.",
        "Two-stage delivery": "Net teslimat süreci",
        "Written by hand · most within 90 min":
          "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
        "Support if something is wrong": "Bir sorun olursa destek",
        "Reply to your order email. Refund eligibility follows our":
          "Sipariş e-postanıza yanıt verin. İade uygunluğu",
        "refund policy": "iade politikamıza tabidir",
        "What happens next": "Sonra ne olur?",
        "Your question and cards stay attached to the order.":
          "Sorunuz ve kartlarınız siparişe bağlı kalır.",
        "Secure checkout": "Güvenli ödeme",
        "One-time purchase": "Tek seferlik satın alma",
        "Your reading is prepared": "Yorumunuz hazırlanır",
        "Written from the exact context collected above.":
          "Yukarıda verdiğiniz tam bağlamdan yazılır.",
        "Email + secure reading page": "E-posta + güvenli yorum sayfası",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
        "Yours to keep": "Sizin için kalıcı",
        "100% digital": "%100 dijital",
        "Prepared for one question": "Tek bir soru için hazırlanır",
        "Example structure of the In-Depth reading":
          "Derinlemesine yorumdan gerçek örnek yapı",
        "Your Love Decision Map": "Aşk Karar Haritanız",
        "Deckaura · personal reading": "Deckaura · kişisel yorum",
        "Why Deckaura reads differently": "Deckaura neden farklı yorumlar?",
        "Context stays connected": "Bağlam kopmaz",
        "Your topic, relationship status, question and cards remain attached from the free reading to the paid one.":
          "Konunuz, ilişki durumunuz, sorunuz ve kartlarınız ücretsiz yorumdan ücretli yoruma birlikte aktarılır.",
        "Grounded language": "Ayakları yere basan dil",
        "Symbolic reflection, without claiming access to anyone’s private mind or promising a fixed date.":
          "Kimsenin özel zihnine erişim iddiası veya kesin tarih vaadi olmadan sembolik yansıma.",
        "Clear next steps": "Net sonraki adımlar",
        "Every reading ends with what you can observe and what remains within your control.":
          "Her yorum gözlemleyebileceğiniz işaretler ve kontrolünüzde kalan adımlarla biter.",
        "Love tarot horoscope or a personal love reading?":
          "Aşk tarotu burç yorumu mu, kişisel aşk yorumu mu?",
        "Common questions": "Sık sorulan sorular",
        "Is the free love tarot reading really free?":
          "Ücretsiz aşk tarotu gerçekten ücretsiz mi?",
        "Yes. The three cards, the interpretation and the next step cost nothing, and no account or payment card is needed.":
          "Evet. Her 24 saatte bir üç kart, yorum ve sonraki adım tamamen ücretsizdir; hesap veya ödeme kartı gerekmez.",
        "Can tarot tell me what someone is really thinking?":
          "Tarot birinin gerçekte ne düşündüğünü söyleyebilir mi?",
        "No, and we will not claim it does. A reading works with symbols. The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
          "Hayır; böyle bir iddiada bulunmayız. Yorum sembollerle çalışır. İkinci kart, diğer kişinin görünür enerjisinin, davranışının ve bağdaki rolünün sembolik olarak nasıl anlaşılabileceğini gösterir.",
        "How accurate is a love tarot reading?":
          "Aşk tarotu ne kadar isabetlidir?",
        "A reading is accurate about patterns, not facts. It reads the dynamic your three cards describe and always ends with something observable you can check in real life, which is where its usefulness is decided.":
          "Yorum, kesin olguları değil örüntüleri anlamaya yarar. Üç kartınızın anlattığı dinamiği okur ve gerçek hayatta kontrol edebileceğiniz gözlemlenebilir bir işaretle biter.",
        "What do I receive if I buy a reading?":
          "Bir yorum satın alırsam ne alırım?",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
        "Do I have to enter my question again after paying?":
          "Ödeme yaptıktan sonra sorumu yeniden girmem gerekir mi?",
        "No. Your focus, relationship status, question and three cards stay attached to your order, so the paid reading continues from the same spread.":
          "Hayır. Odağınız, ilişki durumunuz, sorunuz ve üç kartınız siparişe bağlı kalır; ücretli yorum aynı açılımdan devam eder.",
        "Can I use this love reading if I am single?":
          "Bekârsam bu aşk yorumunu kullanabilir miyim?",
        "Yes. Choose the New love focus and the Single / new love situation. The reading then follows your own readiness and timing instead of a specific person.":
          "Evet. Yeni aşk odağını ve Bekâr / yeni aşk durumunu seçin. Yorum belirli bir kişi yerine kendi hazır oluşunuzu ve zamanlamanızı izler.",
        "Is this like a love psychic reading?":
          "Bu bir medyum aşk yorumu gibi mi?",
        "It is a symbolic card reading, not a psychic claim. Nothing here promises access to another person’s mind; the reading stays with the pattern in your cards and what you can do about it.":
          "Bu sembolik bir kart yorumudur, medyumluk iddiası değildir. Başka birinin zihnine erişim vaat edilmez; yorum kartlarınızdaki örüntüye ve sizin yapabileceklerinize odaklanır.",
        "Do you need my date of birth?": "Doğum tarihime ihtiyacınız var mı?",
        "No. This reading only needs your question. If you want a birth-date based love profile, the zodiac compatibility and birth chart tools below work from exact dates.":
          "Hayır. Bu yorum için yalnızca sorunuz gerekir. Doğum tarihine dayalı aşk profili isterseniz ilgili ücretsiz araçlarımızı kullanabilirsiniz.",
        "Is anything shipped to me?": "Bana fiziksel bir şey gönderilir mi?",
        "Nothing ships. Every reading here is digital and arrives by email, so no address is required.":
          "Fiziksel ürün gönderilmez. Her yorum dijitaldir ve e-postayla gelir; ödeme sağlayıcısı yalnızca faturalandırma bilgisi isteyebilir.",
        "Is my question private?": "Sorum gizli kalır mı?",
        "Your question is used to prepare your reading and nothing else. It is not published, sold or shared.":
          "Sorunuz yalnızca yorumunuzu hazırlamak için kullanılır. Yayınlanmaz, satılmaz veya paylaşılmaz.",
        "Explore related free tools": "İlgili ücretsiz araçları keşfedin",
        "Free tarot reading": "Ücretsiz tarot falı",
        "Any question · 78-card deck": "Her soru · 78 kartlık deste",
        "Yes or no tarot": "Evet-hayır tarotu",
        "One direct question, one card": "Tek doğrudan soru, tek kart",
        "7-card tarot reading": "7 kart tarot falı",
        "A fuller spread for complex situations":
          "Karmaşık durumlar için daha kapsamlı açılım",
        "Daily tarot card": "Günün tarot kartı",
        "One card for today": "Bugün için tek kart",
      },
      topics: {
        feelings: [
          "Onun hisleri",
          "Şu anda görünen",
          "Bu kişinin benimle olan ilişkisinde nasıl davrandığını anlamak için neyi görmeliyim?",
        ],
        intentions: [
          "Onun niyetleri",
          "Neye dönüşebilir",
          "Bu bağın nereye gidebileceğini anlamak için neyi görmeliyim?",
        ],
        reconcile: [
          "Barışma",
          "Değişimin mümkün olup olmadığı",
          "Sağlıklı bir barışmanın mümkün olması için ne değişmeli?",
        ],
        contact: [
          "İletişim ve zamanlama",
          "İletişimi ne hareketlendirir",
          "Şu anda aramızdaki sessizliği şekillendiren nedir?",
        ],
        future: [
          "İlişkinin geleceği",
          "Nereye gidiyor",
          "Bu ilişkinin gidişatı hakkında neyi anlamalıyım?",
        ],
        commitment: [
          "Bağlılık",
          "Derinleşip derinleşmeyeceği",
          "Bu bağın ciddi bir ilişkiye dönüşmesini engelleyen nedir?",
        ],
        newlove: [
          "Yeni aşk",
          "Açılmakta olan",
          "Yeni bir ilişkiye hazır oluşumu şekillendiren nedir?",
        ],
        stayleave: [
          "Kalmak mı ayrılmak mı",
          "Hangi yol sizi korur",
          "Kalma kararı vermeden önce hangi koşula net bakmalıyım?",
        ],
      },
      statuses: {
        crush: ["Hoşlanma / belirsiz", "Erken ve tanımsız"],
        dating: ["Flört", "Birbirinizi tanıyorsunuz"],
        relationship: ["İlişkide", "Şu anda birliktesiniz"],
        separated: ["Ayrı / eski sevgili", "Yakın zamanda ayrıldınız"],
        nocontact: ["İletişim yok", "Aranızda sessizlik var"],
        single: ["Bekâr / yeni aşk", "Yeni birine açıksınız"],
      },
      strings: {
        more: "Daha fazla durum",
        fewer: "Daha az durum göster",
        continue: "Devam et",
        draw: "Üç kartımı çek",
        reveal: "Kartları aç ve yorumla",
        preparing: "Yorumunuz hazırlanıyor…",
        hintStart: "Bir karta dokunun ya da üçünü birden aşağıdan açın.",
        hintMore: "Kartları açmaya devam edin ya da kalanları aşağıdan birlikte açın.",
        checking: "Güvenli fiyat kontrol ediliyor…",
        retryPrice: "Güvenli fiyatı yeniden kontrol et",
        opening: "Güvenli ödeme açılıyor…",
        step: "Adım {n} / 3",
        positions: ["Siz", "Onun görünür rolü", "Gidişat"],
        singlePositions: [
          "Siz",
          "Çektiğiniz ilişki örüntüsü",
          "Sonraki adımınız",
        ],
        askAnother: "Farklı bir soru sor",
        onePerDay: "Her 24 saatte bir ücretsiz açılım",
        delivery:
          "Elle yazılır · çoğu 90 dakika içinde",
        loadingOnly: "Yalnızca seçilen paket açılıyor…",
      },
    },
    de: {
      ui: {
        "Three-card relationship spread": "Drei-Karten-Beziehungslegung",
        "Free Love Tarot Reading": "Kostenloses Liebestarot",
        "Ask one focused relationship question. Reveal three cards and receive an instant symbolic reading about the pattern, what you can observe and your grounded next step.":
          "Stelle eine klare Beziehungsfrage. Decke drei Karten auf und erhalte sofort eine symbolische Deutung des Musters, der beobachtbaren Zeichen und deines nächsten bodenständigen Schritts.",
        "Reveal My Free Love Reading": "Meine kostenlose Liebeslegung öffnen",
        "3 cards": "3 Karten",
        "Instant result": "Sofortiges Ergebnis",
        "No sign-up": "Keine Anmeldung",
        "Start over": "Neu beginnen",
        "Today’s free three-card opening is complete.":
          "Deine heutige kostenlose Drei-Karten-Legung ist abgeschlossen.",
        "You can still shape a private personal reading from this focus and question. Your previous result remains available in the tab where you opened it.":
          "Du kannst aus diesem Fokus und dieser Frage weiterhin eine private persönliche Deutung erstellen. Dein vorheriges Ergebnis bleibt im ursprünglichen Tab verfügbar.",
        "What do you want to understand?": "Was möchtest du verstehen?",
        "Pick one focus. Your cards, your reading and your options all follow from it.":
          "Wähle einen Fokus. Deine Karten, die Deutung und die Optionen richten sich danach.",
        "Where are things right now?": "Wie ist die Situation im Moment?",
        "This changes how the same three cards are read.":
          "Das verändert, wie dieselben drei Karten gedeutet werden.",
        "What would you like to understand clearly?":
          "Was möchtest du klarer verstehen?",
        "Keep it to one relationship and one focused question.":
          "Bleibe bei einer Beziehung und einer klaren Frage.",
        "Your question": "Deine Frage",
        "Need a starting point?": "Brauchst du einen Einstieg?",
        "Open questions read more clearly than yes-or-no questions.":
          "Offene Fragen lassen sich klarer deuten als Ja-Nein-Fragen.",
        "Write your question first — one sentence is enough.":
          "Schreibe zuerst deine Frage; ein Satz genügt.",
        "Your three cards": "Deine drei Karten",
        "← Back": "← Zurück",
        "Your reading": "Deine Legung",
        Focus: "Fokus",
        Situation: "Situation",
        Question: "Frage",
        "Kept on this page during your session. No account, and nothing is shared.":
          "Bleibt während deiner Sitzung auf dieser Seite. Kein Konto, keine Weitergabe.",
        "Your love reading": "Deine Liebeslegung",
        "Your reading leans toward": "Die Tendenz deiner Legung",
        "This is symbolic guidance, not proof of another person’s private thoughts.":
          "Dies ist symbolische Orientierung, kein Beweis für die privaten Gedanken eines anderen Menschen.",
        "Question-specific synthesis": "Auf deine Frage bezogen",
        "All three cards connected": "Alle drei Karten verbunden",
        "Grounded, observable guidance":
          "Bodenständige, überprüfbare Orientierung",
        "Your cards, read for your question":
          "Deine Karten, für deine Frage gedeutet",
        "What the spread is showing": "Was die Legung zeigt",
        "What you can do next": "Was du als Nächstes tun kannst",
        "Why a personal reading is different":
          "Warum eine persönliche Deutung anders ist",
        "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
          "Die kostenlose Deutung beschreibt das Kartenmuster. Eine optionale schriftliche Deutung nutzt dieselbe Frage und Karten, um die entscheidende Bedingung, mögliche Zeitverläufe und praktische nächste Schritte in der gewählten Tiefe zu erkunden.",
        "Continue to reading options →": "Zu den Deutungsoptionen →",
        "ONE FREE OPENING PER 24 HOURS":
          "EINE KOSTENLOSE LEGUNG PRO 24 STUNDEN",
        "Your next love question is still here.":
          "Deine nächste Liebesfrage ist noch da.",
        "Today’s free three-card result has already been opened on this device. You can still take one useful symbolic cue from this question, or continue with a private personal reading.":
          "Das heutige kostenlose Drei-Karten-Ergebnis wurde auf diesem Gerät bereits geöffnet. Du kannst noch einen symbolischen Hinweis mitnehmen oder mit einer privaten persönlichen Deutung fortfahren.",
        "Today’s symbolic cue": "Heutiger symbolischer Hinweis",
        "Your question stays in this tab and is only attached when you choose a reading.":
          "Deine Frage bleibt in diesem Tab und wird erst angehängt, wenn du eine Deutung auswählst.",
        "Your reading context": "Kontext deiner Deutung",
        "Edit question": "Frage bearbeiten",
        Cards: "Karten",
        "Private spread": "Private Legung",
        "Three cards reserved for your personal reading":
          "Drei Karten für deine persönliche Deutung reserviert",
        "First insight now": "Erster Einblick auf dem Bildschirm",
        "Written by hand · most within 90 min":
          "Von Hand geschrieben · meist in 90 Min.",
        "See full details": "Alle Details anzeigen",
        "Private written reading": "Private schriftliche Deutung",
        "Your question, situation and spread stay connected—no generic restart.":
          "Frage, Situation und Legung bleiben verbunden; kein allgemeiner Neustart.",
        "Two-stage delivery": "Klare Lieferung",
        "Written by hand · most within 90 min":
          "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
        "Support if something is wrong": "Hilfe, wenn etwas nicht stimmt",
        "Reply to your order email. Refund eligibility follows our":
          "Antworte auf deine Bestell-E-Mail. Es gilt unsere",
        "refund policy": "Rückerstattungsrichtlinie",
        "What happens next": "Wie es weitergeht",
        "Your question and cards stay attached to the order.":
          "Deine Frage und Karten bleiben mit der Bestellung verbunden.",
        "Secure checkout": "Sicherer Checkout",
        "One-time purchase": "Einmaliger Kauf",
        "Your reading is prepared": "Deine Deutung wird erstellt",
        "Written from the exact context collected above.":
          "Aus genau dem oben erfassten Kontext geschrieben.",
        "Email + secure reading page": "E-Mail + sichere Deutungsseite",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
        "Yours to keep": "Dauerhaft für dich",
        "100% digital": "100 % digital",
        "Prepared for one question": "Für eine Frage erstellt",
        "Example structure of the In-Depth reading":
          "Echtes Strukturbeispiel der ausführlichen Deutung",
        "Your Love Decision Map": "Deine Liebes-Entscheidungskarte",
        "Deckaura · personal reading": "Deckaura · persönliche Deutung",
        "Why Deckaura reads differently": "Warum Deckaura anders deutet",
        "Context stays connected": "Der Kontext bleibt verbunden",
        "Your topic, relationship status, question and cards remain attached from the free reading to the paid one.":
          "Thema, Beziehungsstatus, Frage und Karten bleiben von der kostenlosen bis zur persönlichen Deutung verbunden.",
        "Grounded language": "Bodenständige Sprache",
        "Symbolic reflection, without claiming access to anyone’s private mind or promising a fixed date.":
          "Symbolische Reflexion ohne Anspruch auf private Gedanken oder ein festes Datum.",
        "Clear next steps": "Klare nächste Schritte",
        "Every reading ends with what you can observe and what remains within your control.":
          "Jede Deutung endet mit überprüfbaren Zeichen und dem, was in deiner Hand liegt.",
        "Love tarot horoscope or a personal love reading?":
          "Liebestarot-Horoskop oder persönliche Liebeslegung?",
        "Common questions": "Häufige Fragen",
        "Is the free love tarot reading really free?":
          "Ist das kostenlose Liebestarot wirklich kostenlos?",
        "Yes. The three cards, the interpretation and the next step cost nothing, and no account or payment card is needed.":
          "Ja. Einmal pro 24 Stunden sind drei Karten, Deutung und nächster Schritt kostenlos; Konto oder Zahlungskarte sind nicht nötig.",
        "Can tarot tell me what someone is really thinking?":
          "Kann Tarot sagen, was jemand wirklich denkt?",
        "No, and we will not claim it does. A reading works with symbols. The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
          "Nein, und das behaupten wir nicht. Eine Legung arbeitet mit Symbolen. Die zweite Karte spiegelt, wie sichtbare Energie, Verhalten und Rolle der anderen Seite symbolisch verstanden werden können.",
        "How accurate is a love tarot reading?":
          "Wie treffend ist eine Liebestarot-Legung?",
        "A reading is accurate about patterns, not facts. It reads the dynamic your three cards describe and always ends with something observable you can check in real life, which is where its usefulness is decided.":
          "Eine Legung beschreibt Muster, keine bewiesenen Fakten. Sie deutet die Dynamik der drei Karten und endet mit einem beobachtbaren Zeichen, das du im Alltag prüfen kannst.",
        "What do I receive if I buy a reading?": "Was erhalte ich beim Kauf?",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
        "Do I have to enter my question again after paying?":
          "Muss ich meine Frage nach der Zahlung erneut eingeben?",
        "No. Your focus, relationship status, question and three cards stay attached to your order, so the paid reading continues from the same spread.":
          "Nein. Fokus, Status, Frage und Karten bleiben mit der Bestellung verbunden; die persönliche Deutung setzt dieselbe Legung fort.",
        "Can I use this love reading if I am single?":
          "Kann ich die Legung auch als Single nutzen?",
        "Yes. Choose the New love focus and the Single / new love situation. The reading then follows your own readiness and timing instead of a specific person.":
          "Ja. Wähle Neuer Liebe und Single / neue Liebe. Die Deutung folgt dann deiner Bereitschaft und deinem Timing statt einer bestimmten Person.",
        "Is this like a love psychic reading?":
          "Ist das wie eine hellseherische Liebesdeutung?",
        "It is a symbolic card reading, not a psychic claim. Nothing here promises access to another person’s mind; the reading stays with the pattern in your cards and what you can do about it.":
          "Es ist eine symbolische Kartendeutung, keine hellseherische Behauptung. Sie verspricht keinen Zugang zum Denken anderer, sondern bleibt beim Kartenmuster und deinen Handlungsmöglichkeiten.",
        "Do you need my date of birth?": "Braucht ihr mein Geburtsdatum?",
        "No. This reading only needs your question. If you want a birth-date based love profile, the zodiac compatibility and birth chart tools below work from exact dates.":
          "Nein. Diese Deutung benötigt nur deine Frage. Für ein Profil auf Basis des Geburtsdatums kannst du unsere passenden kostenlosen Werkzeuge nutzen.",
        "Is anything shipped to me?": "Wird mir etwas zugesandt?",
        "Nothing ships. Every reading here is digital and arrives by email, so no address is required.":
          "Es wird nichts physisch versandt. Jede Deutung ist digital und kommt per E-Mail; der Zahlungsanbieter kann lediglich Rechnungsdaten verlangen.",
        "Is my question private?": "Bleibt meine Frage privat?",
        "Your question is used to prepare your reading and nothing else. It is not published, sold or shared.":
          "Deine Frage wird nur für deine Deutung verwendet. Sie wird nicht veröffentlicht, verkauft oder geteilt.",
        "Explore related free tools": "Weitere kostenlose Werkzeuge",
        "Free tarot reading": "Kostenlose Tarotlegung",
        "Any question · 78-card deck": "Jede Frage · 78 Karten",
        "Yes or no tarot": "Ja-Nein-Tarot",
        "One direct question, one card": "Eine direkte Frage, eine Karte",
        "7-card tarot reading": "7-Karten-Tarot",
        "A fuller spread for complex situations":
          "Eine ausführlichere Legung für komplexe Situationen",
        "Daily tarot card": "Tarotkarte des Tages",
        "One card for today": "Eine Karte für heute",
      },
      topics: {
        feelings: [
          "Seine/ihre Gefühle",
          "Was jetzt sichtbar ist",
          "Was sollte ich darüber verstehen, wie diese Person mir gegenüber auftritt?",
        ],
        intentions: [
          "Seine/ihre Absichten",
          "Was sich entwickeln kann",
          "Was sollte ich darüber verstehen, wohin sich diese Verbindung entwickeln kann?",
        ],
        reconcile: [
          "Versöhnung",
          "Ob echte Veränderung möglich ist",
          "Was müsste sich ändern, damit eine gesunde Versöhnung möglich wird?",
        ],
        contact: [
          "Kontakt & Timing",
          "Was Kommunikation bewegt",
          "Was prägt gerade die Stille zwischen uns?",
        ],
        future: [
          "Zukunft der Beziehung",
          "Wohin sie führt",
          "Was sollte ich über die Richtung dieser Beziehung verstehen?",
        ],
        commitment: [
          "Verbindlichkeit",
          "Ob es sich vertieft",
          "Was hält diese Verbindung von echter Verbindlichkeit ab?",
        ],
        newlove: [
          "Neue Liebe",
          "Was sich öffnet",
          "Was prägt meine Bereitschaft für eine neue Beziehung?",
        ],
        stayleave: [
          "Bleiben oder gehen",
          "Welcher Weg dich schützt",
          "Welche Bedingung sollte ich vor der Entscheidung klar ansehen?",
        ],
      },
      statuses: {
        crush: ["Schwarm / unklar", "Früh und undefiniert"],
        dating: ["Dating", "Ihr lernt euch kennen"],
        relationship: ["In einer Beziehung", "Ihr seid zusammen"],
        separated: ["Getrennt / Ex", "Vor Kurzem getrennt"],
        nocontact: ["Kein Kontakt", "Stille zwischen euch"],
        single: ["Single / neue Liebe", "Offen für jemanden Neuen"],
      },
      strings: {
        more: "Weitere Situationen",
        fewer: "Weniger Situationen",
        continue: "Weiter",
        draw: "Meine drei Karten ziehen",
        reveal: "Karten aufdecken und deuten",
        preparing: "Deine Deutung wird vorbereitet…",
        hintStart: "Tippe auf eine Karte oder decke unten alle drei zusammen auf.",
        hintMore: "Decke weitere Karten auf oder decke die übrigen unten gemeinsam auf.",
        checking: "Sicherer Preis wird geprüft…",
        retryPrice: "Preisprüfung wiederholen",
        opening: "Sicherer Checkout wird geöffnet…",
        step: "Schritt {n} von 3",
        positions: [
          "Du",
          "Sichtbare Rolle der anderen Seite",
          "Wohin es führt",
        ],
        singlePositions: ["Du", "Was du anziehst", "Dein nächster Schritt"],
        askAnother: "Eine andere Frage stellen",
        onePerDay: "Eine kostenlose Legung pro 24 Stunden",
        delivery:
          "Von Hand geschrieben · meist in 90 Min.",
        loadingOnly: "Nur das gewählte Paket wird geöffnet…",
      },
    },
    es: {
      ui: {
        "Three-card relationship spread": "Tirada de relación de tres cartas",
        "Free Love Tarot Reading": "Tarot del amor gratis",
        "Ask one focused relationship question. Reveal three cards and receive an instant symbolic reading about the pattern, what you can observe and your grounded next step.":
          "Haz una sola pregunta clara sobre tu relación. Revela tres cartas y recibe al instante una lectura simbólica del patrón, las señales observables y tu siguiente paso con los pies en la tierra.",
        "Reveal My Free Love Reading": "Revelar mi lectura de amor gratis",
        "3 cards": "3 cartas",
        "Instant result": "Resultado inmediato",
        "No sign-up": "Sin registro",
        "Start over": "Empezar de nuevo",
        "Today’s free three-card opening is complete.":
          "La tirada gratuita de tres cartas de hoy ya está completa.",
        "You can still shape a private personal reading from this focus and question. Your previous result remains available in the tab where you opened it.":
          "Aún puedes crear una lectura personal y privada desde este enfoque y esta pregunta. Tu resultado anterior sigue disponible en la pestaña donde lo abriste.",
        "What do you want to understand?": "¿Qué quieres comprender?",
        "Pick one focus. Your cards, your reading and your options all follow from it.":
          "Elige un enfoque. Tus cartas, tu lectura y tus opciones se adaptarán a él.",
        "Where are things right now?": "¿En qué punto estáis ahora?",
        "This changes how the same three cards are read.":
          "Esto cambia la forma de interpretar las mismas tres cartas.",
        "What would you like to understand clearly?":
          "¿Qué te gustaría comprender con claridad?",
        "Keep it to one relationship and one focused question.":
          "Céntrate en una relación y una sola pregunta.",
        "Your question": "Tu pregunta",
        "Need a starting point?": "¿Necesitas una idea para empezar?",
        "Open questions read more clearly than yes-or-no questions.":
          "Las preguntas abiertas se leen con más claridad que las de sí o no.",
        "Write your question first — one sentence is enough.":
          "Escribe primero tu pregunta; una frase es suficiente.",
        "Your three cards": "Tus tres cartas",
        "← Back": "← Atrás",
        "Your reading": "Tu lectura",
        Focus: "Enfoque",
        Situation: "Situación",
        Question: "Pregunta",
        "Kept on this page during your session. No account, and nothing is shared.":
          "Se conserva en esta página durante tu sesión. Sin cuenta y sin compartir nada.",
        "Your love reading": "Tu lectura de amor",
        "Your reading leans toward": "La tendencia de tu lectura",
        "This is symbolic guidance, not proof of another person’s private thoughts.":
          "Es orientación simbólica, no una prueba de los pensamientos privados de otra persona.",
        "Question-specific synthesis": "Síntesis para tu pregunta",
        "All three cards connected": "Las tres cartas conectadas",
        "Grounded, observable guidance": "Orientación práctica y observable",
        "Your cards, read for your question":
          "Tus cartas, interpretadas para tu pregunta",
        "What the spread is showing": "Lo que muestra la tirada",
        "What you can do next": "Lo que puedes hacer ahora",
        "Why a personal reading is different":
          "Por qué una lectura personal es diferente",
        "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
          "La lectura gratuita describe el patrón de las cartas. Una lectura escrita opcional usa la misma pregunta y cartas para explorar la condición decisiva, posibles ritmos y próximos pasos prácticos con la profundidad elegida.",
        "Continue to reading options →":
          "Continuar a las opciones de lectura →",
        "ONE FREE OPENING PER 24 HOURS": "UNA TIRADA GRATIS CADA 24 HORAS",
        "Your next love question is still here.":
          "Tu nueva pregunta de amor sigue aquí.",
        "Today’s free three-card result has already been opened on this device. You can still take one useful symbolic cue from this question, or continue with a private personal reading.":
          "El resultado gratuito de hoy ya se abrió en este dispositivo. Aún puedes llevarte una señal simbólica útil o continuar con una lectura personal privada.",
        "Today’s symbolic cue": "Señal simbólica de hoy",
        "Your question stays in this tab and is only attached when you choose a reading.":
          "Tu pregunta permanece en esta pestaña y solo se adjunta cuando eliges una lectura.",
        "Your reading context": "Contexto de tu lectura",
        "Edit question": "Editar pregunta",
        Cards: "Cartas",
        "Private spread": "Tirada privada",
        "Three cards reserved for your personal reading":
          "Tres cartas reservadas para tu lectura personal",
        "First insight now": "Primera orientación en pantalla",
        "Written by hand · most within 90 min":
          "Escrita a mano · la mayoría en 90 min",
        "See full details": "Ver todos los detalles",
        "Private written reading": "Lectura escrita privada",
        "Your question, situation and spread stay connected—no generic restart.":
          "Tu pregunta, situación y tirada permanecen conectadas; no se reinicia con algo genérico.",
        "Two-stage delivery": "Entrega clara",
        "Written by hand · most within 90 min":
          "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
        "Support if something is wrong": "Ayuda si algo no está bien",
        "Reply to your order email. Refund eligibility follows our":
          "Responde al email del pedido. Se aplica nuestra",
        "refund policy": "política de reembolso",
        "What happens next": "Qué ocurre después",
        "Your question and cards stay attached to the order.":
          "Tu pregunta y tus cartas quedan adjuntas al pedido.",
        "Secure checkout": "Pago seguro",
        "One-time purchase": "Compra única",
        "Your reading is prepared": "Se prepara tu lectura",
        "Written from the exact context collected above.":
          "Escrita con el contexto exacto recogido arriba.",
        "Email + secure reading page": "Email + página de lectura segura",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
        "Yours to keep": "Tuya para siempre",
        "100% digital": "100 % digital",
        "Prepared for one question": "Preparada para una pregunta",
        "Example structure of the In-Depth reading":
          "Ejemplo real de la estructura de la lectura profunda",
        "Your Love Decision Map": "Tu mapa de decisiones amorosas",
        "Deckaura · personal reading": "Deckaura · lectura personal",
        "Why Deckaura reads differently": "Por qué Deckaura lee de otra manera",
        "Context stays connected": "El contexto permanece conectado",
        "Your topic, relationship status, question and cards remain attached from the free reading to the paid one.":
          "Tu tema, situación, pregunta y cartas siguen unidas desde la lectura gratuita hasta la personal.",
        "Grounded language": "Lenguaje realista",
        "Symbolic reflection, without claiming access to anyone’s private mind or promising a fixed date.":
          "Reflexión simbólica sin afirmar acceso a una mente privada ni prometer una fecha fija.",
        "Clear next steps": "Siguientes pasos claros",
        "Every reading ends with what you can observe and what remains within your control.":
          "Cada lectura termina con lo que puedes observar y lo que sigue bajo tu control.",
        "Love tarot horoscope or a personal love reading?":
          "¿Horóscopo de tarot amoroso o lectura personal?",
        "Common questions": "Preguntas frecuentes",
        "Is the free love tarot reading really free?":
          "¿La lectura de amor gratuita es realmente gratis?",
        "Yes. The three cards, the interpretation and the next step cost nothing, and no account or payment card is needed.":
          "Sí. Una vez cada 24 horas, las tres cartas, la interpretación y el siguiente paso no cuestan nada; no necesitas cuenta ni tarjeta.",
        "Can tarot tell me what someone is really thinking?":
          "¿Puede el tarot decir lo que alguien piensa de verdad?",
        "No, and we will not claim it does. A reading works with symbols. The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
          "No, y no lo afirmamos. Una lectura trabaja con símbolos. La segunda carta refleja cómo pueden entenderse simbólicamente la energía visible, la conducta y el papel de la otra parte.",
        "How accurate is a love tarot reading?":
          "¿Qué precisión tiene una lectura de amor?",
        "A reading is accurate about patterns, not facts. It reads the dynamic your three cards describe and always ends with something observable you can check in real life, which is where its usefulness is decided.":
          "Una lectura describe patrones, no hechos demostrados. Lee la dinámica de las tres cartas y termina con una señal observable que puedes comprobar en la vida real.",
        "What do I receive if I buy a reading?":
          "¿Qué recibo si compro una lectura?",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
        "Do I have to enter my question again after paying?":
          "¿Debo volver a escribir mi pregunta después de pagar?",
        "No. Your focus, relationship status, question and three cards stay attached to your order, so the paid reading continues from the same spread.":
          "No. Tu enfoque, situación, pregunta y cartas quedan adjuntos al pedido, de modo que la lectura personal continúa la misma tirada.",
        "Can I use this love reading if I am single?":
          "¿Puedo usar esta lectura si estoy soltero/a?",
        "Yes. Choose the New love focus and the Single / new love situation. The reading then follows your own readiness and timing instead of a specific person.":
          "Sí. Elige Nuevo amor y Soltero/a / nuevo amor. La lectura seguirá tu propia disposición y ritmo en vez de centrarse en una persona concreta.",
        "Is this like a love psychic reading?":
          "¿Es como una lectura psíquica del amor?",
        "It is a symbolic card reading, not a psychic claim. Nothing here promises access to another person’s mind; the reading stays with the pattern in your cards and what you can do about it.":
          "Es una lectura simbólica de cartas, no una afirmación psíquica. No promete acceso a la mente de otra persona; se centra en el patrón y en lo que puedes hacer.",
        "Do you need my date of birth?": "¿Necesitáis mi fecha de nacimiento?",
        "No. This reading only needs your question. If you want a birth-date based love profile, the zodiac compatibility and birth chart tools below work from exact dates.":
          "No. Esta lectura solo necesita tu pregunta. Si buscas un perfil basado en la fecha de nacimiento, puedes usar nuestras herramientas gratuitas relacionadas.",
        "Is anything shipped to me?": "¿Se envía algo físicamente?",
        "Nothing ships. Every reading here is digital and arrives by email, so no address is required.":
          "No se envía nada físico. Todas las lecturas son digitales y llegan por email; el proveedor de pago puede pedir datos de facturación.",
        "Is my question private?": "¿Mi pregunta es privada?",
        "Your question is used to prepare your reading and nothing else. It is not published, sold or shared.":
          "Tu pregunta solo se usa para preparar tu lectura. No se publica, vende ni comparte.",
        "Explore related free tools":
          "Explora herramientas gratuitas relacionadas",
        "Free tarot reading": "Lectura de tarot gratis",
        "Any question · 78-card deck":
          "Cualquier pregunta · baraja de 78 cartas",
        "Yes or no tarot": "Tarot de sí o no",
        "One direct question, one card": "Una pregunta directa, una carta",
        "7-card tarot reading": "Lectura de tarot de 7 cartas",
        "A fuller spread for complex situations":
          "Una tirada más completa para situaciones complejas",
        "Daily tarot card": "Carta del tarot diaria",
        "One card for today": "Una carta para hoy",
      },
      topics: {
        feelings: [
          "Sus sentimientos",
          "Lo que se muestra ahora",
          "¿Qué necesito comprender sobre cómo se presenta esta persona conmigo?",
        ],
        intentions: [
          "Sus intenciones",
          "Lo que puede desarrollarse",
          "¿Qué necesito comprender sobre hacia dónde puede ir esta conexión?",
        ],
        reconcile: [
          "Reconciliación",
          "Si puede cambiar",
          "¿Qué tendría que cambiar para que una reconciliación sana fuera posible?",
        ],
        contact: [
          "Contacto y tiempos",
          "Qué mueve la comunicación",
          "¿Qué está dando forma al silencio entre nosotros?",
        ],
        future: [
          "Futuro de la relación",
          "Hacia dónde se dirige",
          "¿Qué debo comprender sobre la dirección de esta relación?",
        ],
        commitment: [
          "Compromiso",
          "Si se profundiza",
          "¿Qué impide que esta conexión se convierta en un compromiso?",
        ],
        newlove: [
          "Nuevo amor",
          "Lo que se abre",
          "¿Qué está dando forma a mi disposición para una nueva relación?",
        ],
        stayleave: [
          "Quedarse o irse",
          "Qué camino te protege",
          "¿Qué condición debo mirar con claridad antes de decidir?",
        ],
      },
      statuses: {
        crush: ["Me gusta / incierto", "Inicio sin definir"],
        dating: ["Saliendo", "Os estáis conociendo"],
        relationship: ["En una relación", "Juntos ahora"],
        separated: ["Separados / ex", "Separación reciente"],
        nocontact: ["Sin contacto", "Silencio entre vosotros"],
        single: ["Soltero/a / nuevo amor", "Abierto/a a alguien nuevo"],
      },
      strings: {
        more: "Más situaciones",
        fewer: "Mostrar menos situaciones",
        continue: "Continuar",
        draw: "Sacar mis tres cartas",
        reveal: "Revelar e interpretar las cartas",
        preparing: "Preparando tu lectura…",
        hintStart: "Toca una carta o revela abajo las tres juntas.",
        hintMore: "Sigue girando cartas o revela abajo las restantes.",
        checking: "Comprobando el precio seguro…",
        retryPrice: "Reintentar la comprobación",
        opening: "Abriendo el pago seguro…",
        step: "Paso {n} de 3",
        positions: [
          "Tú",
          "Papel visible de la otra parte",
          "Hacia dónde se dirige",
        ],
        singlePositions: ["Tú", "Lo que atraes", "Tu siguiente paso"],
        askAnother: "Hacer otra pregunta",
        onePerDay: "Una tirada gratis cada 24 horas",
        delivery:
          "Escrita a mano · la mayoría en 90 min",
        loadingOnly: "Solo se está abriendo el paquete elegido…",
      },
    },
    pt: {
      ui: {
        "Three-card relationship spread":
          "Tiragem de relacionamento com três cartas",
        "Free Love Tarot Reading": "Tarot do amor grátis",
        "Ask one focused relationship question. Reveal three cards and receive an instant symbolic reading about the pattern, what you can observe and your grounded next step.":
          "Faça uma pergunta clara sobre a relação. Revele três cartas e receba de imediato uma leitura simbólica sobre o padrão, os sinais observáveis e o seu próximo passo prático.",
        "Reveal My Free Love Reading": "Revelar a minha leitura de amor grátis",
        "3 cards": "3 cartas",
        "Instant result": "Resultado imediato",
        "No sign-up": "Sem registo",
        "Start over": "Recomeçar",
        "Today’s free three-card opening is complete.":
          "A tiragem gratuita de três cartas de hoje está concluída.",
        "You can still shape a private personal reading from this focus and question. Your previous result remains available in the tab where you opened it.":
          "Ainda pode criar uma leitura pessoal e privada a partir deste foco e desta pergunta. O resultado anterior continua disponível no separador onde o abriu.",
        "What do you want to understand?": "O que quer compreender?",
        "Pick one focus. Your cards, your reading and your options all follow from it.":
          "Escolha um foco. As cartas, a leitura e as opções seguem essa escolha.",
        "Where are things right now?": "Como está a situação neste momento?",
        "This changes how the same three cards are read.":
          "Isto muda a forma como as mesmas três cartas são interpretadas.",
        "What would you like to understand clearly?":
          "O que gostaria de compreender com clareza?",
        "Keep it to one relationship and one focused question.":
          "Concentre-se numa relação e numa pergunta clara.",
        "Your question": "A sua pergunta",
        "Need a starting point?": "Precisa de uma ideia para começar?",
        "Open questions read more clearly than yes-or-no questions.":
          "Perguntas abertas permitem uma leitura mais clara do que perguntas de sim ou não.",
        "Write your question first — one sentence is enough.":
          "Escreva primeiro a pergunta; uma frase é suficiente.",
        "Your three cards": "As suas três cartas",
        "← Back": "← Voltar",
        "Your reading": "A sua leitura",
        Focus: "Foco",
        Situation: "Situação",
        Question: "Pergunta",
        "Kept on this page during your session. No account, and nothing is shared.":
          "Mantido nesta página durante a sessão. Sem conta e sem partilha.",
        "Your love reading": "A sua leitura de amor",
        "Your reading leans toward": "A tendência da sua leitura",
        "This is symbolic guidance, not proof of another person’s private thoughts.":
          "Esta é uma orientação simbólica, não uma prova dos pensamentos privados de outra pessoa.",
        "Question-specific synthesis": "Síntese para a sua pergunta",
        "All three cards connected": "As três cartas ligadas",
        "Grounded, observable guidance": "Orientação prática e observável",
        "Your cards, read for your question":
          "As suas cartas, lidas para a sua pergunta",
        "What the spread is showing": "O que a tiragem mostra",
        "What you can do next": "O que pode fazer agora",
        "Why a personal reading is different":
          "Porque uma leitura pessoal é diferente",
        "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
          "A leitura gratuita descreve o padrão das cartas. Uma leitura escrita opcional usa a mesma pergunta e cartas para explorar a condição decisiva, diferentes possibilidades de ritmo e próximos passos práticos na profundidade escolhida.",
        "Continue to reading options →":
          "Continuar para as opções de leitura →",
        "ONE FREE OPENING PER 24 HOURS": "UMA TIRAGEM GRÁTIS A CADA 24 HORAS",
        "Your next love question is still here.":
          "A sua nova pergunta de amor continua aqui.",
        "Today’s free three-card result has already been opened on this device. You can still take one useful symbolic cue from this question, or continue with a private personal reading.":
          "O resultado gratuito de hoje já foi aberto neste dispositivo. Ainda pode retirar um sinal simbólico útil ou continuar com uma leitura pessoal privada.",
        "Today’s symbolic cue": "Sinal simbólico de hoje",
        "Your question stays in this tab and is only attached when you choose a reading.":
          "A pergunta fica neste separador e só é anexada quando escolhe uma leitura.",
        "Your reading context": "Contexto da sua leitura",
        "Edit question": "Editar pergunta",
        Cards: "Cartas",
        "Private spread": "Tiragem privada",
        "Three cards reserved for your personal reading":
          "Três cartas reservadas para a sua leitura pessoal",
        "First insight now": "Primeira orientação no ecrã",
        "Written by hand · most within 90 min":
          "Escrita à mão · a maioria em 90 min",
        "See full details": "Ver todos os detalhes",
        "Private written reading": "Leitura escrita privada",
        "Your question, situation and spread stay connected—no generic restart.":
          "A pergunta, a situação e a tiragem permanecem ligadas; sem recomeço genérico.",
        "Two-stage delivery": "Entrega clara",
        "Written by hand · most within 90 min":
          "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
        "Support if something is wrong": "Apoio se algo estiver errado",
        "Reply to your order email. Refund eligibility follows our":
          "Responda ao email da encomenda. Aplica-se a nossa",
        "refund policy": "política de reembolso",
        "What happens next": "O que acontece a seguir",
        "Your question and cards stay attached to the order.":
          "A pergunta e as cartas permanecem anexadas à encomenda.",
        "Secure checkout": "Pagamento seguro",
        "One-time purchase": "Compra única",
        "Your reading is prepared": "A sua leitura é preparada",
        "Written from the exact context collected above.":
          "Escrita a partir do contexto exato recolhido acima.",
        "Email + secure reading page": "Email + página de leitura segura",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
        "Yours to keep": "Sua para guardar",
        "100% digital": "100% digital",
        "Prepared for one question": "Preparada para uma pergunta",
        "Example structure of the In-Depth reading":
          "Exemplo real da estrutura da leitura aprofundada",
        "Your Love Decision Map": "O seu mapa de decisões amorosas",
        "Deckaura · personal reading": "Deckaura · leitura pessoal",
        "Why Deckaura reads differently":
          "Porque a Deckaura lê de forma diferente",
        "Context stays connected": "O contexto permanece ligado",
        "Your topic, relationship status, question and cards remain attached from the free reading to the paid one.":
          "O tema, a situação, a pergunta e as cartas permanecem ligados da leitura gratuita à pessoal.",
        "Grounded language": "Linguagem realista",
        "Symbolic reflection, without claiming access to anyone’s private mind or promising a fixed date.":
          "Reflexão simbólica sem afirmar acesso à mente privada de alguém nem prometer uma data fixa.",
        "Clear next steps": "Próximos passos claros",
        "Every reading ends with what you can observe and what remains within your control.":
          "Cada leitura termina com o que pode observar e com aquilo que continua sob o seu controlo.",
        "Love tarot horoscope or a personal love reading?":
          "Horóscopo de tarot do amor ou leitura pessoal?",
        "Common questions": "Perguntas frequentes",
        "Is the free love tarot reading really free?":
          "A leitura gratuita de amor é mesmo grátis?",
        "Yes. The three cards, the interpretation and the next step cost nothing, and no account or payment card is needed.":
          "Sim. Uma vez a cada 24 horas, as três cartas, a interpretação e o passo seguinte são gratuitos; não precisa de conta nem cartão.",
        "Can tarot tell me what someone is really thinking?":
          "O tarot pode dizer o que alguém pensa realmente?",
        "No, and we will not claim it does. A reading works with symbols. The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
          "Não, e não fazemos essa afirmação. Uma leitura trabalha com símbolos. A segunda carta reflete como a energia visível, o comportamento e o papel da outra parte podem ser entendidos simbolicamente.",
        "How accurate is a love tarot reading?":
          "Qual é a precisão de uma leitura de amor?",
        "A reading is accurate about patterns, not facts. It reads the dynamic your three cards describe and always ends with something observable you can check in real life, which is where its usefulness is decided.":
          "Uma leitura descreve padrões, não factos comprovados. Lê a dinâmica das três cartas e termina com um sinal observável que pode verificar na vida real.",
        "What do I receive if I buy a reading?":
          "O que recebo se comprar uma leitura?",
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
          "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
        "Do I have to enter my question again after paying?":
          "Tenho de voltar a escrever a pergunta depois de pagar?",
        "No. Your focus, relationship status, question and three cards stay attached to your order, so the paid reading continues from the same spread.":
          "Não. O foco, a situação, a pergunta e as cartas ficam anexados à encomenda; a leitura pessoal continua a mesma tiragem.",
        "Can I use this love reading if I am single?":
          "Posso usar esta leitura se estiver solteiro/a?",
        "Yes. Choose the New love focus and the Single / new love situation. The reading then follows your own readiness and timing instead of a specific person.":
          "Sim. Escolha Novo amor e Solteiro/a / novo amor. A leitura seguirá a sua disponibilidade e o seu ritmo em vez de uma pessoa específica.",
        "Is this like a love psychic reading?":
          "É como uma leitura psíquica de amor?",
        "It is a symbolic card reading, not a psychic claim. Nothing here promises access to another person’s mind; the reading stays with the pattern in your cards and what you can do about it.":
          "É uma leitura simbólica de cartas, não uma afirmação psíquica. Não promete acesso à mente de outra pessoa; mantém-se no padrão das cartas e no que pode fazer.",
        "Do you need my date of birth?":
          "Precisam da minha data de nascimento?",
        "No. This reading only needs your question. If you want a birth-date based love profile, the zodiac compatibility and birth chart tools below work from exact dates.":
          "Não. Esta leitura precisa apenas da sua pergunta. Para um perfil baseado na data de nascimento, pode usar as nossas ferramentas gratuitas relacionadas.",
        "Is anything shipped to me?": "É enviado algum produto físico?",
        "Nothing ships. Every reading here is digital and arrives by email, so no address is required.":
          "Não é enviado nada fisicamente. Todas as leituras são digitais e chegam por email; o fornecedor de pagamento pode pedir dados de faturação.",
        "Is my question private?": "A minha pergunta é privada?",
        "Your question is used to prepare your reading and nothing else. It is not published, sold or shared.":
          "A pergunta é usada apenas para preparar a leitura. Não é publicada, vendida nem partilhada.",
        "Explore related free tools":
          "Explore ferramentas gratuitas relacionadas",
        "Free tarot reading": "Leitura de tarot grátis",
        "Any question · 78-card deck":
          "Qualquer pergunta · baralho de 78 cartas",
        "Yes or no tarot": "Tarot de sim ou não",
        "One direct question, one card": "Uma pergunta direta, uma carta",
        "7-card tarot reading": "Leitura de tarot de 7 cartas",
        "A fuller spread for complex situations":
          "Uma tiragem mais completa para situações complexas",
        "Daily tarot card": "Carta de tarot diária",
        "One card for today": "Uma carta para hoje",
      },
      topics: {
        feelings: [
          "Os sentimentos da outra parte",
          "O que se mostra agora",
          "O que preciso de compreender sobre a forma como esta pessoa se apresenta comigo?",
        ],
        intentions: [
          "As intenções da outra parte",
          "O que se pode desenvolver",
          "O que preciso de compreender sobre o rumo desta ligação?",
        ],
        reconcile: [
          "Reconciliação",
          "Se pode mudar",
          "O que teria de mudar para uma reconciliação saudável ser possível?",
        ],
        contact: [
          "Contacto e timing",
          "O que move a comunicação",
          "O que está a moldar o silêncio entre nós?",
        ],
        future: [
          "Futuro da relação",
          "Para onde se dirige",
          "O que devo compreender sobre a direção desta relação?",
        ],
        commitment: [
          "Compromisso",
          "Se aprofunda",
          "O que impede esta ligação de se tornar um compromisso?",
        ],
        newlove: [
          "Novo amor",
          "O que se está a abrir",
          "O que está a moldar a minha disponibilidade para uma nova relação?",
        ],
        stayleave: [
          "Ficar ou partir",
          "Que caminho o/a protege",
          "Que condição devo observar claramente antes de decidir?",
        ],
      },
      statuses: {
        crush: ["Interesse / incerteza", "Início indefinido"],
        dating: ["A conhecer alguém", "Estão a conhecer-se"],
        relationship: ["Numa relação", "Juntos agora"],
        separated: ["Separados / ex", "Separação recente"],
        nocontact: ["Sem contacto", "Silêncio entre vocês"],
        single: ["Solteiro/a / novo amor", "Aberto/a a alguém novo"],
      },
      strings: {
        more: "Mais situações",
        fewer: "Mostrar menos situações",
        continue: "Continuar",
        draw: "Tirar as minhas três cartas",
        reveal: "Revelar e interpretar as cartas",
        preparing: "A preparar a sua leitura…",
        hintStart: "Toque numa carta ou revele as três em conjunto abaixo.",
        hintMore: "Continue a virar cartas ou revele as restantes em conjunto abaixo.",
        checking: "A verificar o preço seguro…",
        retryPrice: "Repetir a verificação",
        opening: "A abrir o pagamento seguro…",
        step: "Passo {n} de 3",
        positions: [
          "Você",
          "Papel visível da outra parte",
          "Para onde se dirige",
        ],
        singlePositions: ["Você", "O que atrai", "O seu próximo passo"],
        askAnother: "Fazer outra pergunta",
        onePerDay: "Uma tiragem grátis a cada 24 horas",
        delivery:
          "Escrita à mão · a maioria em 90 min",
        loadingOnly: "Apenas o pacote escolhido está a abrir…",
      },
    },
  };

  var EN_TOPICS = {
    feelings: [
      "Their feelings",
      "What is showing now",
      "What do I need to understand about how this person is showing up with me?",
    ],
    intentions: [
      "Their intentions",
      "What may develop",
      "What do I need to understand about where this connection may be going?",
    ],
    reconcile: [
      "Reconciliation",
      "Whether it can change",
      "What would need to change for a healthy reconciliation to become possible?",
    ],
    contact: [
      "Contact & timing",
      "What moves communication",
      "What is shaping the silence between us right now?",
    ],
    future: [
      "Relationship future",
      "Where this is heading",
      "What should I understand about where this relationship is heading?",
    ],
    commitment: [
      "Commitment",
      "Whether it deepens",
      "What is holding this connection back from becoming committed?",
    ],
    newlove: [
      "New love",
      "What is opening",
      "What is shaping my readiness for a new relationship?",
    ],
    stayleave: [
      "Stay or leave",
      "Which path protects you",
      "What condition should I look at most clearly before deciding whether to stay?",
    ],
  };
  var EN_STATUSES = {
    unspecified: ["Not specified", "No relationship status assumed"],
    crush: ["Crush / unsure", "Early and undefined"],
    dating: ["Dating", "Getting to know each other"],
    relationship: ["In a relationship", "Together now"],
    separated: ["Separated / ex", "Recently apart"],
    nocontact: ["No contact", "Silence between you"],
    single: ["Single / new love", "Open to someone new"],
  };
  var EN_STRINGS = {
    more: "More situations",
    fewer: "Show fewer situations",
    continue: "Continue",
    draw: "Draw my three cards",
    reveal: "Reveal & interpret my spread",
    preparing: "Preparing your reading…",
    hintStart: "Tap any card, or reveal all three together below.",
    hintMore: "Keep turning cards, or reveal the rest together below.",
    checking: "Checking secure price…",
    retryPrice: "Retry secure price check",
    opening: "Opening secure checkout…",
    step: "Step {n} of 3",
    positions: ["You", "Their observable role", "Where it is heading"],
    singlePositions: ["You", "What you attract", "Your next step"],
    askAnother: "Ask a different question",
    onePerDay: "1 free spread per 24 hours",
    delivery: "Written by hand · most within 90 min",
    loadingOnly: "Only the selected package is opening…",
  };

  var MAJOR = {
    tr: [
      "Deli",
      "Büyücü",
      "Başrahibe",
      "İmparatoriçe",
      "İmparator",
      "Aziz",
      "Âşıklar",
      "Savaş Arabası",
      "Güç",
      "Ermiş",
      "Kader Çarkı",
      "Adalet",
      "Asılan Adam",
      "Ölüm",
      "Denge",
      "Şeytan",
      "Kule",
      "Yıldız",
      "Ay",
      "Güneş",
      "Mahkeme",
      "Dünya",
    ],
    de: [
      "Der Narr",
      "Der Magier",
      "Die Hohepriesterin",
      "Die Herrscherin",
      "Der Herrscher",
      "Der Hierophant",
      "Die Liebenden",
      "Der Wagen",
      "Die Kraft",
      "Der Eremit",
      "Rad des Schicksals",
      "Die Gerechtigkeit",
      "Der Gehängte",
      "Der Tod",
      "Die Mäßigkeit",
      "Der Teufel",
      "Der Turm",
      "Der Stern",
      "Der Mond",
      "Die Sonne",
      "Das Gericht",
      "Die Welt",
    ],
    es: [
      "El Loco",
      "El Mago",
      "La Sacerdotisa",
      "La Emperatriz",
      "El Emperador",
      "El Hierofante",
      "Los Enamorados",
      "El Carro",
      "La Fuerza",
      "El Ermitaño",
      "La Rueda de la Fortuna",
      "La Justicia",
      "El Colgado",
      "La Muerte",
      "La Templanza",
      "El Diablo",
      "La Torre",
      "La Estrella",
      "La Luna",
      "El Sol",
      "El Juicio",
      "El Mundo",
    ],
    pt: [
      "O Louco",
      "O Mago",
      "A Sacerdotisa",
      "A Imperatriz",
      "O Imperador",
      "O Hierofante",
      "Os Enamorados",
      "O Carro",
      "A Força",
      "O Eremita",
      "A Roda da Fortuna",
      "A Justiça",
      "O Enforcado",
      "A Morte",
      "A Temperança",
      "O Diabo",
      "A Torre",
      "A Estrela",
      "A Lua",
      "O Sol",
      "O Julgamento",
      "O Mundo",
    ],
  };
  var MAJOR_EN = [
    "The Fool",
    "The Magician",
    "The High Priestess",
    "The Empress",
    "The Emperor",
    "The Hierophant",
    "The Lovers",
    "The Chariot",
    "Strength",
    "The Hermit",
    "Wheel of Fortune",
    "Justice",
    "The Hanged Man",
    "Death",
    "Temperance",
    "The Devil",
    "The Tower",
    "The Star",
    "The Moon",
    "The Sun",
    "Judgement",
    "The World",
  ];
  var MINOR = {
    tr: {
      ranks: {
        Ace: "As",
        Two: "İkili",
        Three: "Üçlü",
        Four: "Dörtlü",
        Five: "Beşli",
        Six: "Altılı",
        Seven: "Yedili",
        Eight: "Sekizli",
        Nine: "Dokuzlu",
        Ten: "Onlu",
        Page: "Prens",
        Knight: "Şövalye",
        Queen: "Kraliçe",
        King: "Kral",
      },
      suits: {
        Wands: "Değnek",
        Cups: "Kupa",
        Swords: "Kılıç",
        Pentacles: "Tılsım",
      },
      join: function (r, s) {
        return s + " " + r;
      },
    },
    de: {
      ranks: {
        Ace: "Ass",
        Two: "Zwei",
        Three: "Drei",
        Four: "Vier",
        Five: "Fünf",
        Six: "Sechs",
        Seven: "Sieben",
        Eight: "Acht",
        Nine: "Neun",
        Ten: "Zehn",
        Page: "Bube",
        Knight: "Ritter",
        Queen: "Königin",
        King: "König",
      },
      suits: {
        Wands: "Stäbe",
        Cups: "Kelche",
        Swords: "Schwerter",
        Pentacles: "Münzen",
      },
      join: function (r, s) {
        return r + " der " + s;
      },
    },
    es: {
      ranks: {
        Ace: "As",
        Two: "Dos",
        Three: "Tres",
        Four: "Cuatro",
        Five: "Cinco",
        Six: "Seis",
        Seven: "Siete",
        Eight: "Ocho",
        Nine: "Nueve",
        Ten: "Diez",
        Page: "Sota",
        Knight: "Caballero",
        Queen: "Reina",
        King: "Rey",
      },
      suits: {
        Wands: "Bastos",
        Cups: "Copas",
        Swords: "Espadas",
        Pentacles: "Oros",
      },
      join: function (r, s) {
        return r + " de " + s;
      },
    },
    pt: {
      ranks: {
        Ace: "Ás",
        Two: "Dois",
        Three: "Três",
        Four: "Quatro",
        Five: "Cinco",
        Six: "Seis",
        Seven: "Sete",
        Eight: "Oito",
        Nine: "Nove",
        Ten: "Dez",
        Page: "Valete",
        Knight: "Cavaleiro",
        Queen: "Rainha",
        King: "Rei",
      },
      suits: {
        Wands: "Paus",
        Cups: "Copas",
        Swords: "Espadas",
        Pentacles: "Ouros",
      },
      join: function (r, s) {
        return r + " de " + s;
      },
    },
  };

  var TIER_DATA = {
    en: [
      {
        badge: "Essential",
        promise: "Clarify the one uncertainty keeping you stuck.",
        bullets: [
          "A direct response to your exact question",
          "The condition shaping the result",
          "One next step within your control",
          "One action to avoid",
        ],
        cta: "Clarify This Answer",
        words: "450–600 words",
      },
      {
        badge: "Focused",
        promise: "Understand the pattern behind the mixed signals.",
        bullets: [
          "Everything in Essential",
          "Feelings vs. intentions vs. likely action",
          "The central tension in the connection",
          "Three signs of real progress",
          "Your personalized next move",
        ],
        cta: "Reveal the Full Dynamic",
        words: "750–950 words",
      },
      {
        badge: "Decision path",
        promise: "Turn the reading into a grounded relationship decision.",
        bullets: [
          "Everything in Focused",
          "Two possible paths compared",
          "Timing pace and turning points",
          "Risks, boundaries and safeguards",
          "A practical 30-day decision plan",
        ],
        cta: "Build My 30-Day Path",
        words: "1,250–1,500 words",
      },
    ],
    tr: [
      {
        badge: "Temel",
        promise: "Sizi yerinizde tutan tek belirsizliği netleştirin.",
        bullets: [
          "Tam sorunuza doğrudan yanıt",
          "Sonucu şekillendiren koşul",
          "Kontrolünüzdeki bir sonraki adım",
          "Kaçınmanız gereken bir hareket",
        ],
        cta: "Bu Yanıtı Netleştir",
        words: "450–600 kelime",
      },
      {
        badge: "Odaklı",
        promise: "Karışık sinyallerin ardındaki örüntüyü anlayın.",
        bullets: [
          "Temel paketteki her şey",
          "Hisler, niyetler ve olası hareket",
          "Bağdaki temel gerilim",
          "Gerçek ilerlemenin üç işareti",
          "Size özel bir sonraki hareket",
        ],
        cta: "Tüm Dinamiği Aç",
        words: "750–950 kelime",
      },
      {
        badge: "Karar yolu",
        promise: "Yorumu ayakları yere basan bir ilişki kararına dönüştürün.",
        bullets: [
          "Odaklı paketteki her şey",
          "İki olası yolun karşılaştırması",
          "Zamanlama temposu ve dönüm noktaları",
          "Riskler, sınırlar ve koruyucu adımlar",
          "Uygulanabilir 30 günlük karar planı",
        ],
        cta: "30 Günlük Yolumu Oluştur",
        words: "1.250–1.500 kelime",
      },
    ],
    de: [
      {
        badge: "Basis",
        promise: "Kläre die eine Unsicherheit, die dich festhält.",
        bullets: [
          "Direkte Antwort auf deine genaue Frage",
          "Die Bedingung, die das Ergebnis prägt",
          "Ein nächster Schritt in deiner Hand",
          "Eine Handlung, die du vermeiden solltest",
        ],
        cta: "Diese Antwort klären",
        words: "450–600 Wörter",
      },
      {
        badge: "Fokussiert",
        promise: "Verstehe das Muster hinter den gemischten Signalen.",
        bullets: [
          "Alles aus der Basisdeutung",
          "Gefühle, Absichten und wahrscheinliche Handlung",
          "Die zentrale Spannung der Verbindung",
          "Drei Zeichen echten Fortschritts",
          "Dein persönlicher nächster Schritt",
        ],
        cta: "Die ganze Dynamik zeigen",
        words: "750–950 Wörter",
      },
      {
        badge: "Entscheidungsweg",
        promise:
          "Mache aus der Deutung eine bodenständige Beziehungsentscheidung.",
        bullets: [
          "Alles aus der fokussierten Deutung",
          "Zwei mögliche Wege im Vergleich",
          "Timing und Wendepunkte",
          "Risiken, Grenzen und Schutz",
          "Praktischer 30-Tage-Entscheidungsplan",
        ],
        cta: "Meinen 30-Tage-Weg erstellen",
        words: "1.250–1.500 Wörter",
      },
    ],
    es: [
      {
        badge: "Esencial",
        promise: "Aclara la única incertidumbre que te mantiene bloqueado/a.",
        bullets: [
          "Respuesta directa a tu pregunta exacta",
          "La condición que da forma al resultado",
          "Un siguiente paso bajo tu control",
          "Una acción que conviene evitar",
        ],
        cta: "Aclarar esta respuesta",
        words: "450–600 palabras",
      },
      {
        badge: "Enfocada",
        promise: "Comprende el patrón detrás de las señales contradictorias.",
        bullets: [
          "Todo lo incluido en la lectura Esencial",
          "Sentimientos, intenciones y acción probable",
          "La tensión central de la conexión",
          "Tres señales de progreso real",
          "Tu siguiente movimiento personal",
        ],
        cta: "Revelar toda la dinámica",
        words: "750–950 palabras",
      },
      {
        badge: "Camino de decisión",
        promise: "Convierte la lectura en una decisión de relación realista.",
        bullets: [
          "Todo lo incluido en la lectura Enfocada",
          "Comparación de dos caminos posibles",
          "Ritmo y puntos de inflexión",
          "Riesgos, límites y protección",
          "Plan práctico de decisión de 30 días",
        ],
        cta: "Crear mi camino de 30 días",
        words: "1.250–1.500 palabras",
      },
    ],
    pt: [
      {
        badge: "Essencial",
        promise: "Esclareça a única incerteza que o/a mantém preso/a.",
        bullets: [
          "Resposta direta à sua pergunta exata",
          "A condição que molda o resultado",
          "Um próximo passo sob o seu controlo",
          "Uma ação a evitar",
        ],
        cta: "Esclarecer esta resposta",
        words: "450–600 palavras",
      },
      {
        badge: "Focada",
        promise: "Compreenda o padrão por trás dos sinais contraditórios.",
        bullets: [
          "Tudo o que está na leitura Essencial",
          "Sentimentos, intenções e ação provável",
          "A tensão central da ligação",
          "Três sinais de progresso real",
          "O seu próximo movimento pessoal",
        ],
        cta: "Revelar toda a dinâmica",
        words: "750–950 palavras",
      },
      {
        badge: "Caminho de decisão",
        promise: "Transforme a leitura numa decisão de relação realista.",
        bullets: [
          "Tudo o que está na leitura Focada",
          "Comparação de dois caminhos possíveis",
          "Ritmo e pontos de viragem",
          "Riscos, limites e proteção",
          "Plano prático de decisão de 30 dias",
        ],
        cta: "Criar o meu caminho de 30 dias",
        words: "1.250–1.500 palavras",
      },
    ],
  };

  var SINGLE_TIER_DATA = {
    en: [
      {
        badge: "Essential",
        promise: "Clarify what to release and what to welcome next.",
        bullets: [
          "A direct response to your exact question",
          "The condition shaping your readiness",
          "One next step within your control",
          "One pattern to avoid repeating",
        ],
        cta: "Clarify My Next Opening",
        words: "450–600 words",
      },
      {
        badge: "Focused",
        promise:
          "Understand what a healthier new connection needs from you now.",
        bullets: [
          "Everything in Essential",
          "Readiness, chemistry and emotional availability",
          "The relationship pattern you are leaving",
          "Three signs of mutual availability",
          "Your personalized next move",
        ],
        cta: "Reveal My New-Love Pattern",
        words: "750–950 words",
      },
      {
        badge: "Decision path",
        promise: "Turn the reading into a grounded path toward new love.",
        bullets: [
          "Everything in Focused",
          "Old and healthier patterns compared",
          "Timing pace and readiness",
          "Standards, boundaries and safeguards",
          "A practical 30-day openness plan",
        ],
        cta: "Build My 30-Day Path",
        words: "1,250–1,500 words",
      },
    ],
    tr: [
      {
        badge: "Temel",
        promise: "Neyi bırakıp sırada neye alan açacağınızı netleştirin.",
        bullets: [
          "Tam sorunuza doğrudan yanıt",
          "Hazır oluşunuzu şekillendiren koşul",
          "Kontrolünüzdeki bir sonraki adım",
          "Tekrarlamamanız gereken bir örüntü",
        ],
        cta: "Sıradaki Açılımımı Netleştir",
        words: "450–600 kelime",
      },
      {
        badge: "Odaklı",
        promise:
          "Daha sağlıklı yeni bir bağın şimdi sizden ne istediğini anlayın.",
        bullets: [
          "Temel paketteki her şey",
          "Hazır oluş, kimya ve duygusal erişilebilirlik",
          "Geride bıraktığınız ilişki örüntüsü",
          "Karşılıklı erişilebilirliğin üç işareti",
          "Size özel bir sonraki hamle",
        ],
        cta: "Yeni Aşk Örüntümü Aç",
        words: "750–950 kelime",
      },
      {
        badge: "Karar yolu",
        promise:
          "Yorumu yeni aşka doğru ayakları yere basan bir yola dönüştürün.",
        bullets: [
          "Odaklı paketteki her şey",
          "Eski ve daha sağlıklı örüntülerin karşılaştırması",
          "Zamanlama ritmi ve hazır oluş",
          "Standartlar, sınırlar ve koruma",
          "Uygulanabilir 30 günlük açıklık planı",
        ],
        cta: "30 Günlük Yolumu Oluştur",
        words: "1.250–1.500 kelime",
      },
    ],
    de: [
      {
        badge: "Essentiell",
        promise:
          "Kläre, was du loslassen und als Nächstes willkommen heißen solltest.",
        bullets: [
          "Direkte Antwort auf deine genaue Frage",
          "Die Bedingung, die deine Bereitschaft prägt",
          "Ein nächster Schritt in deiner Hand",
          "Ein Muster, das du nicht wiederholen solltest",
        ],
        cta: "Meine nächste Öffnung klären",
        words: "450–600 Wörter",
      },
      {
        badge: "Fokussiert",
        promise:
          "Verstehe, was eine gesündere neue Verbindung jetzt von dir braucht.",
        bullets: [
          "Alles aus der Basisdeutung",
          "Bereitschaft, Chemie und emotionale Verfügbarkeit",
          "Das Beziehungsmuster, das du zurücklässt",
          "Drei Zeichen gegenseitiger Verfügbarkeit",
          "Dein persönlicher nächster Schritt",
        ],
        cta: "Mein neues Liebesmuster erkennen",
        words: "750–950 Wörter",
      },
      {
        badge: "Entscheidungsweg",
        promise:
          "Mache aus der Deutung einen bodenständigen Weg zu neuer Liebe.",
        bullets: [
          "Alles aus der fokussierten Deutung",
          "Altes und gesünderes Muster im Vergleich",
          "Timing, Tempo und Bereitschaft",
          "Maßstäbe, Grenzen und Schutz",
          "Ein praktischer 30-Tage-Plan für Offenheit",
        ],
        cta: "Meinen 30-Tage-Weg erstellen",
        words: "1.250–1.500 Wörter",
      },
    ],
    es: [
      {
        badge: "Esencial",
        promise: "Aclara qué soltar y qué recibir a continuación.",
        bullets: [
          "Respuesta directa a tu pregunta exacta",
          "La condición que define tu disposición",
          "Un siguiente paso bajo tu control",
          "Un patrón que conviene no repetir",
        ],
        cta: "Aclarar mi próxima apertura",
        words: "450–600 palabras",
      },
      {
        badge: "Enfocada",
        promise:
          "Comprende qué necesita ahora de ti una conexión nueva y más sana.",
        bullets: [
          "Todo lo incluido en la lectura Esencial",
          "Disposición, química y disponibilidad emocional",
          "El patrón de relación que estás dejando",
          "Tres señales de disponibilidad mutua",
          "Tu siguiente movimiento personal",
        ],
        cta: "Revelar mi patrón de nuevo amor",
        words: "750–950 palabras",
      },
      {
        badge: "Camino de decisión",
        promise:
          "Convierte la lectura en un camino realista hacia un nuevo amor.",
        bullets: [
          "Todo lo incluido en la lectura Enfocada",
          "Comparación entre el patrón antiguo y uno más sano",
          "Ritmo, tiempo y disposición",
          "Criterios, límites y protección",
          "Plan práctico de apertura de 30 días",
        ],
        cta: "Crear mi camino de 30 días",
        words: "1.250–1.500 palabras",
      },
    ],
    pt: [
      {
        badge: "Essencial",
        promise: "Esclareça o que deve libertar e o que acolher a seguir.",
        bullets: [
          "Resposta direta à sua pergunta exata",
          "A condição que molda a sua disponibilidade",
          "Um próximo passo sob o seu controlo",
          "Um padrão a evitar repetir",
        ],
        cta: "Esclarecer a minha próxima abertura",
        words: "450–600 palavras",
      },
      {
        badge: "Focada",
        promise:
          "Compreenda o que uma nova ligação mais saudável precisa agora de si.",
        bullets: [
          "Tudo o que está na leitura Essencial",
          "Disponibilidade, química e abertura emocional",
          "O padrão de relação que está a deixar",
          "Três sinais de disponibilidade mútua",
          "O seu próximo movimento pessoal",
        ],
        cta: "Revelar o meu padrão de novo amor",
        words: "750–950 palavras",
      },
      {
        badge: "Caminho de decisão",
        promise: "Transforme a leitura num caminho realista para um novo amor.",
        bullets: [
          "Tudo o que está na leitura Focada",
          "Comparação entre o padrão antigo e um mais saudável",
          "Ritmo, tempo e disponibilidade",
          "Critérios, limites e proteção",
          "Plano prático de abertura de 30 dias",
        ],
        cta: "Criar o meu caminho de 30 dias",
        words: "1.250–1.500 palavras",
      },
    ],
  };

  var VERDICTS = {
    en: {
      opening: "There is room to move forward, if actions match the promise",
      mixed:
        "The connection is active, but the deciding condition is still open",
      caution:
        "The attraction may be real, but the current pattern needs a boundary",
      ending: "This cycle needs closure before a healthier direction can begin",
      singleOpening: "A healthier opening is beginning to form",
      singleMixed: "New love opens as an old pattern loosens",
      singleCaution: "Protect your standards while a new pattern forms",
      singleEnding: "An ending is clearing space for a different kind of love",
    },
    tr: {
      opening: "Sözler davranışla eşleşirse ilerlemek için alan var",
      mixed: "Bağ hâlâ aktif, ancak belirleyici koşul açıkta",
      caution:
        "Çekim gerçek olabilir, fakat mevcut örüntü net bir sınır istiyor",
      ending:
        "Daha sağlıklı bir yön başlamadan önce bu döngünün kapanması gerekiyor",
      singleOpening: "Daha sağlıklı bir başlangıç oluşmaya başlıyor",
      singleMixed: "Eski bir örüntü gevşedikçe yeni aşk için alan açılıyor",
      singleCaution: "Yeni bir örüntü oluşurken standartlarınızı koruyun",
      singleEnding: "Bir bitiş, farklı bir aşk için alan açıyor",
    },
    de: {
      opening:
        "Es gibt Raum für Fortschritt, wenn Handlungen zum Versprechen passen",
      mixed:
        "Die Verbindung ist aktiv, doch die entscheidende Bedingung bleibt offen",
      caution:
        "Die Anziehung kann echt sein, aber das aktuelle Muster braucht eine Grenze",
      ending:
        "Dieser Zyklus braucht Abschluss, bevor eine gesündere Richtung beginnen kann",
      singleOpening: "Eine gesündere Öffnung beginnt sich zu zeigen",
      singleMixed:
        "Neue Liebe öffnet sich, während ein altes Muster lockerer wird",
      singleCaution:
        "Schütze deine Maßstäbe, während ein neues Muster entsteht",
      singleEnding: "Ein Ende schafft Raum für eine andere Art von Liebe",
    },
    es: {
      opening: "Hay espacio para avanzar si los hechos cumplen la promesa",
      mixed:
        "La conexión sigue activa, pero la condición decisiva está abierta",
      caution:
        "La atracción puede ser real, pero el patrón actual necesita un límite",
      ending:
        "Este ciclo necesita cerrarse antes de que empiece una dirección más sana",
      singleOpening: "Empieza a formarse una apertura más sana",
      singleMixed: "El nuevo amor se abre cuando afloja un patrón antiguo",
      singleCaution: "Protege tus criterios mientras se forma un patrón nuevo",
      singleEnding:
        "Un final está dejando espacio para una forma distinta de amar",
    },
    pt: {
      opening: "Há espaço para avançar se as ações corresponderem à promessa",
      mixed:
        "A ligação continua ativa, mas a condição decisiva permanece em aberto",
      caution:
        "A atração pode ser real, mas o padrão atual precisa de um limite",
      ending:
        "Este ciclo precisa de encerramento antes de começar uma direção mais saudável",
      singleOpening: "Começa a formar-se uma abertura mais saudável",
      singleMixed:
        "Um novo amor abre-se à medida que um padrão antigo se solta",
      singleCaution:
        "Proteja os seus critérios enquanto se forma um novo padrão",
      singleEnding:
        "Um fim está a abrir espaço para uma forma diferente de amar",
    },
  };
  var EXTRA_UI = {
    tr: {
      "Your focus": "Odağınız",
      "Your situation": "Durumunuz",
      "1 free spread per 24 hours": "24 saatte 1 ücretsiz açılım",
      "Ask a different question": "Farklı bir soru sor",
      "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
        "Ücretsiz yorum kartların örüntüsünü gösterir. İsteğe bağlı, kişisel yazılı yorum aynı soru ve kartlarla belirleyici koşulu, farklı zamanlama olasılıklarını ve seçtiğiniz kapsamda uygulanabilir sonraki adımları inceler.",
      "Private written reading": "Özel yazılı yorum",
      "Private written reading":
        "Özel yazılı yorum",
      "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
        "Deckaura yorumcusu, geleneksel tarot sembolizmini kullanarak yorumunuzu sorunuz, bağlamınız ve kartlarınızdan elle yazar. Yorum düşünmeye yardımcı olur; sonuçları garanti etmez veya özel düşünceleri ortaya çıkarmaz.",
      "About Deckaura and the method →": "Deckaura ve yorum yöntemi hakkında →",
      "Full reading by email + secure page":
        "Tam yorum e-posta + güvenli sayfayla",
      "Written by hand · most within 90 min":
        "Elle yazılır · çoğu 90 dakika içinde",
      "Delivery you can plan for": "Planlayabileceğiniz teslimat",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
      "A real excerpt shows the difference": "Gerçek bir örnek farkı gösterir",
      "Anonymized example · Focused reading":
        "Anonimleştirilmiş örnek · Focused yorum",
      "The two Swords cards do not make this connection emotionless; they show that both sides are trying to manage it through thought and self-protection. The Devil in the direction position is the deciding card: the pull is still active, but so is the cycle that made closeness costly. Before you wait, test whether one calm boundary produces consistent action over the next seven days.":
        "İki Kılıç kartı bu bağın duygusuz olduğunu söylemiyor; iki tarafın da düşünce ve kendini koruma yoluyla durumu yönetmeye çalıştığını gösteriyor. Gidişat pozisyonundaki Şeytan belirleyici kart: çekim hâlâ aktif, ancak yakınlığı zorlaştıran döngü de öyle. Beklemeden önce sakin bir sınırın önümüzdeki yedi günde tutarlı davranış üretip üretmediğini sınayın.",
      "Example passage; every paid reading is written from the customer’s own question and cards.":
        "Örnek pasaj; her ücretli yorum müşterinin kendi sorusu ve kartlarından yazılır.",
      "No physical item ships. Every reading is digital and arrives by email; Shopify checkout may still request billing details for payment verification.":
        "Fiziksel ürün gönderilmez. Her yorum dijitaldir ve e-postayla gelir; Shopify ödeme doğrulaması için fatura bilgileri isteyebilir.",
      "Continue from this exact question and private spread":
        "Bu tam soru ve özel açılımdan devam edin",
      "Continue from the exact question and cards above":
        "Yukarıdaki tam soru ve kartlardan devam edin",
      "Today’s free three-card opening has already been used on this device. Your new focus, situation and question are still attached to the reading you choose.":
        "Bugünkü ücretsiz üç kart açılımı bu cihazda kullanıldı. Yeni odağınız, durumunuz ve sorunuz seçtiğiniz yoruma bağlı kalır.",
      "No restart and no generic reading. Your question, situation and three-card result stay attached to the reading you choose.":
        "Baştan başlama ve genel yorum yok. Sorunuz, durumunuz ve üç kart sonucunuz seçtiğiniz yoruma bağlı kalır.",
      "The second card reflects the qualities, availability and relationship pattern you are currently ready to attract.":
        "İkinci kart, şu anda çekmeye hazır olduğunuz nitelikleri, duygusal erişilebilirliği ve ilişki örüntüsünü gösterir.",
      "The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
        "İkinci kart, diğer tarafın görünür enerjisinin, davranışının ve bağdaki rolünün sembolik olarak nasıl anlaşılabileceğini gösterir.",
      "Yes. One free three-card opening is available per 24 hours on this device. The cards, interpretation and next step cost nothing; no account or payment card is needed.":
        "Evet. Bu cihazda her 24 saatte bir ücretsiz üç kart açılımı kullanılabilir. Kartlar, yorum ve sonraki adım ücretsizdir; hesap veya ödeme kartı gerekmez.",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
      "No. This reading only needs your question. For a birth-date based love profile, open the related free birth tools from the Tools menu.":
        "Hayır. Bu yorum yalnızca sorunuzu gerektirir. Doğum tarihine dayalı bir aşk profili için Araçlar menüsündeki ilgili ücretsiz doğum araçlarını açın.",
    },
    de: {
      "Your focus": "Dein Fokus",
      "Your situation": "Deine Situation",
      "1 free spread per 24 hours": "1 kostenlose Legung pro 24 Stunden",
      "Ask a different question": "Eine andere Frage stellen",
      "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
        "Die kostenlose Deutung beschreibt das Kartenmuster. Eine optionale schriftliche Deutung nutzt dieselbe Frage und Karten, um die entscheidende Bedingung, mögliche Zeitverläufe und praktische nächste Schritte in der gewählten Tiefe zu erkunden.",
      "Private written reading": "Private schriftliche Deutung",
      "Private written reading":
        "Private schriftliche Deutung",
      "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
        "Deine Deutung wird aus deiner Frage, deinem Kontext und deinen Karten mit traditioneller Tarot-Symbolik von Hand geschrieben. Sie dient der Reflexion und garantiert keine Ergebnisse oder Einblicke in private Gedanken.",
      "About Deckaura and the method →": "Über Deckaura und die Methode →",
      "Full reading by email + secure page":
        "Vollständige Deutung per E-Mail + sicherer Seite",
      "Written by hand · most within 90 min":
        "Von Hand geschrieben · meist in 90 Min.",
      "Delivery you can plan for": "Planbare Lieferung",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
      "A real excerpt shows the difference":
        "Ein echter Auszug zeigt den Unterschied",
      "Anonymized example · Focused reading":
        "Anonymisiertes Beispiel · Focused-Deutung",
      "The two Swords cards do not make this connection emotionless; they show that both sides are trying to manage it through thought and self-protection. The Devil in the direction position is the deciding card: the pull is still active, but so is the cycle that made closeness costly. Before you wait, test whether one calm boundary produces consistent action over the next seven days.":
        "Die zwei Schwerterkarten machen diese Verbindung nicht gefühllos; sie zeigen, dass beide Seiten sie über Denken und Selbstschutz steuern. Der Teufel in der Richtungsposition ist die entscheidende Karte: Die Anziehung ist noch aktiv, aber ebenso der Kreislauf, der Nähe teuer gemacht hat. Prüfe vor dem Warten, ob eine ruhige Grenze in den nächsten sieben Tagen beständiges Handeln auslöst.",
      "Example passage; every paid reading is written from the customer’s own question and cards.":
        "Beispielauszug; jede bezahlte Deutung wird aus der eigenen Frage und den eigenen Karten geschrieben.",
      "No physical item ships. Every reading is digital and arrives by email; Shopify checkout may still request billing details for payment verification.":
        "Es wird nichts physisch versandt. Jede Deutung ist digital und kommt per E-Mail; Shopify kann zur Zahlungsprüfung Rechnungsdaten anfordern.",
      "Continue from this exact question and private spread":
        "Mit dieser genauen Frage und privaten Legung fortfahren",
      "Continue from the exact question and cards above":
        "Mit der genauen Frage und den Karten oben fortfahren",
      "Today’s free three-card opening has already been used on this device. Your new focus, situation and question are still attached to the reading you choose.":
        "Die heutige kostenlose Drei-Karten-Legung wurde auf diesem Gerät genutzt. Fokus, Situation und neue Frage bleiben mit der gewählten Deutung verbunden.",
      "No restart and no generic reading. Your question, situation and three-card result stay attached to the reading you choose.":
        "Kein Neustart und keine allgemeine Deutung. Frage, Situation und Drei-Karten-Ergebnis bleiben mit der Auswahl verbunden.",
      "The second card reflects the qualities, availability and relationship pattern you are currently ready to attract.":
        "Die zweite Karte spiegelt die Eigenschaften, Verfügbarkeit und das Beziehungsmuster, für das du gerade bereit bist.",
      "The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
        "Die zweite Karte spiegelt, wie sichtbare Energie, Verhalten und Rolle der anderen Seite symbolisch verstanden werden können.",
      "Yes. One free three-card opening is available per 24 hours on this device. The cards, interpretation and next step cost nothing; no account or payment card is needed.":
        "Ja. Auf diesem Gerät ist alle 24 Stunden eine kostenlose Drei-Karten-Legung verfügbar. Karten, Deutung und nächster Schritt sind kostenlos; Konto oder Zahlungskarte sind nicht nötig.",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
      "No. This reading only needs your question. For a birth-date based love profile, open the related free birth tools from the Tools menu.":
        "Nein. Diese Deutung benötigt nur deine Frage. Für ein Liebesprofil nach Geburtsdatum öffnest du die passenden kostenlosen Geburtswerkzeuge im Menü Werkzeuge.",
    },
    es: {
      "Your focus": "Tu enfoque",
      "Your situation": "Tu situación",
      "1 free spread per 24 hours": "1 tirada gratis cada 24 horas",
      "Ask a different question": "Hacer otra pregunta",
      "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
        "La lectura gratuita describe el patrón de las cartas. Una lectura escrita opcional usa la misma pregunta y cartas para explorar la condición decisiva, posibles ritmos y próximos pasos prácticos con la profundidad elegida.",
      "Private written reading": "Lectura escrita privada",
      "Private written reading":
        "Lectura escrita privada",
      "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
        "En Deckaura usamos el simbolismo tradicional del tarot para escribir a mano tu interpretación a partir de tu pregunta, contexto y cartas. Ayuda a reflexionar; no garantiza resultados ni revela pensamientos privados.",
      "About Deckaura and the method →": "Sobre Deckaura y el método →",
      "Full reading by email + secure page":
        "Lectura completa por email + página segura",
      "Written by hand · most within 90 min":
        "Escrita a mano · la mayoría en 90 min",
      "Delivery you can plan for": "Entrega que puedes planificar",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
      "A real excerpt shows the difference":
        "Un fragmento real muestra la diferencia",
      "Anonymized example · Focused reading":
        "Ejemplo anónimo · lectura Focused",
      "The two Swords cards do not make this connection emotionless; they show that both sides are trying to manage it through thought and self-protection. The Devil in the direction position is the deciding card: the pull is still active, but so is the cycle that made closeness costly. Before you wait, test whether one calm boundary produces consistent action over the next seven days.":
        "Las dos cartas de Espadas no vuelven fría esta conexión; muestran que ambas partes intentan manejarla desde el pensamiento y la autoprotección. El Diablo en la posición de dirección es la carta decisiva: la atracción sigue activa, pero también el ciclo que hizo costosa la cercanía. Antes de esperar, comprueba si un límite tranquilo produce acciones constantes durante los próximos siete días.",
      "Example passage; every paid reading is written from the customer’s own question and cards.":
        "Fragmento de ejemplo; cada lectura de pago se escribe desde la pregunta y las cartas del cliente.",
      "No physical item ships. Every reading is digital and arrives by email; Shopify checkout may still request billing details for payment verification.":
        "No se envía ningún artículo físico. Todas las lecturas son digitales y llegan por email; Shopify puede pedir datos de facturación para verificar el pago.",
      "Continue from this exact question and private spread":
        "Continuar desde esta pregunta y tirada privada",
      "Continue from the exact question and cards above":
        "Continuar desde la pregunta y las cartas de arriba",
      "Today’s free three-card opening has already been used on this device. Your new focus, situation and question are still attached to the reading you choose.":
        "La tirada gratuita de hoy ya se usó en este dispositivo. Tu nuevo enfoque, situación y pregunta siguen unidos a la lectura que elijas.",
      "No restart and no generic reading. Your question, situation and three-card result stay attached to the reading you choose.":
        "Sin reinicios ni lecturas genéricas. Tu pregunta, situación y resultado de tres cartas siguen unidos a tu elección.",
      "The second card reflects the qualities, availability and relationship pattern you are currently ready to attract.":
        "La segunda carta refleja las cualidades, la disponibilidad y el patrón de relación que ahora estás preparado/a para atraer.",
      "The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
        "La segunda carta refleja cómo pueden entenderse simbólicamente la energía visible, la conducta y el papel de la otra parte.",
      "Yes. One free three-card opening is available per 24 hours on this device. The cards, interpretation and next step cost nothing; no account or payment card is needed.":
        "Sí. En este dispositivo hay una tirada gratuita de tres cartas cada 24 horas. Las cartas, la interpretación y el siguiente paso no cuestan nada; no necesitas cuenta ni tarjeta.",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
      "No. This reading only needs your question. For a birth-date based love profile, open the related free birth tools from the Tools menu.":
        "No. Esta lectura solo necesita tu pregunta. Para un perfil amoroso basado en la fecha de nacimiento, abre las herramientas gratuitas relacionadas desde el menú Herramientas.",
    },
    pt: {
      "Your focus": "O seu foco",
      "Your situation": "A sua situação",
      "1 free spread per 24 hours": "1 tiragem grátis a cada 24 horas",
      "Ask a different question": "Fazer outra pergunta",
      "The free reading outlines the card pattern. An optional private written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.":
        "A leitura gratuita descreve o padrão das cartas. Uma leitura escrita opcional usa a mesma pergunta e cartas para explorar a condição decisiva, diferentes possibilidades de ritmo e próximos passos práticos na profundidade escolhida.",
      "Private written reading": "Lectura escrita privada",
      "Private written reading":
        "Leitura escrita privada",
      "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
        "Na Deckaura, usamos o simbolismo tradicional do tarot para escrever à mão a sua interpretação a partir da sua pergunta, contexto e cartas. Apoia a reflexão; não garante resultados nem revela pensamentos privados.",
      "About Deckaura and the method →": "Sobre Deckaura y el método →",
      "Full reading by email + secure page":
        "Leitura completa por email + página segura",
      "Written by hand · most within 90 min":
        "Escrita à mão · a maioria em 90 min",
      "Delivery you can plan for": "Entrega que pode planear",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
      "A real excerpt shows the difference":
        "Um excerto real mostra a diferença",
      "Anonymized example · Focused reading":
        "Exemplo anónimo · leitura Focused",
      "The two Swords cards do not make this connection emotionless; they show that both sides are trying to manage it through thought and self-protection. The Devil in the direction position is the deciding card: the pull is still active, but so is the cycle that made closeness costly. Before you wait, test whether one calm boundary produces consistent action over the next seven days.":
        "As duas cartas de Espadas não tornam esta ligação sem emoção; mostram que ambos os lados tentam geri-la através do pensamento e da autoproteção. O Diabo na posição de direção é a carta decisiva: a atração continua ativa, mas também o ciclo que tornou a proximidade dispendiosa. Antes de esperar, teste se um limite calmo produz ações consistentes nos próximos sete dias.",
      "Example passage; every paid reading is written from the customer’s own question and cards.":
        "Excerto de exemplo; cada leitura paga é escrita a partir da pergunta e das cartas do cliente.",
      "No physical item ships. Every reading is digital and arrives by email; Shopify checkout may still request billing details for payment verification.":
        "Não é enviado qualquer artigo físico. Todas as leituras são digitais e chegam por email; a Shopify pode pedir dados de faturação para verificar o pagamento.",
      "Continue from this exact question and private spread":
        "Continuar a partir desta pergunta e tiragem privada",
      "Continue from the exact question and cards above":
        "Continuar a partir da pergunta e das cartas acima",
      "Today’s free three-card opening has already been used on this device. Your new focus, situation and question are still attached to the reading you choose.":
        "A tiragem gratuita de hoje já foi usada neste dispositivo. O novo foco, a situação e a pergunta continuam ligados à leitura escolhida.",
      "No restart and no generic reading. Your question, situation and three-card result stay attached to the reading you choose.":
        "Sem recomeços nem leitura genérica. A pergunta, a situação e o resultado de três cartas permanecem ligados à sua escolha.",
      "The second card reflects the qualities, availability and relationship pattern you are currently ready to attract.":
        "A segunda carta reflete as qualidades, a disponibilidade e o padrão de relação que está agora preparado/a para atrair.",
      "The second card reflects how the other person’s visible energy, behaviour and role in the connection may be understood symbolically.":
        "A segunda carta reflete como a energia visível, o comportamento e o papel da outra parte podem ser entendidos simbolicamente.",
      "Yes. One free three-card opening is available per 24 hours on this device. The cards, interpretation and next step cost nothing; no account or payment card is needed.":
        "Sim. Neste dispositivo está disponível uma tiragem gratuita de três cartas a cada 24 horas. As cartas, a interpretação e o passo seguinte são gratuitos; não precisa de conta nem cartão.",
      "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
        "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
      "No. This reading only needs your question. For a birth-date based love profile, open the related free birth tools from the Tools menu.":
        "Não. Esta leitura precisa apenas da sua pergunta. Para um perfil amoroso baseado na data de nascimento, abra as ferramentas gratuitas relacionadas no menu Ferramentas.",
    },
  };

  Object.assign(EXTRA_UI.tr, {
    "Retrying secure price check…": "Güvenli fiyat kontrolü yeniden deneniyor…",
    "Checkout could not be prepared. Your reading is safe; please try again.":
      "Ödeme güvenle hazırlanamadı. Yorumunuz güvende; lütfen tekrar deneyin.",
    "Secure checkout did not open. Please try again; your reading is still here.":
      "Güvenli ödeme açılmadı. Lütfen tekrar deneyin; yorumunuz hâlâ burada.",
    "Checkout did not open. Your reading is safe; please try again.":
      "Ödeme açılmadı. Yorumunuz güvende; lütfen tekrar deneyin.",
    "Write your question first.": "Önce sorunuzu yazın.",
    "Your personalized reading options are ready.":
      "Kişisel yorum seçenekleriniz hazır.",
    "Your cards are ready. Turn each card over.":
      "Kartlarınız hazır. Her kartı çevirin.",
    "All three cards are turned.": "Üç kartın tamamı açıldı.",
    "Your free reading is ready.": "Ücretsiz yorumunuz hazır.",
    "Edit your question, then continue without re-entering your focus or situation.":
      "Odağınızı veya durumunuzu yeniden girmeden sorunuzu düzenleyip devam edin.",
    "Keep it to one new-love pattern and one focused question.":
      "Tek bir yeni aşk örüntüsüne ve tek bir odaklı soruya bağlı kalın.",
    "Three cards, instant result, no sign-up":
      "Üç kart, anında sonuç, kayıt yok",
    "Reading focus": "Yorum odağı",
    "Relationship situation": "İlişki durumu",
    "Question examples": "Soru örnekleri",
    "Reading options": "Yorum seçenekleri",
    "Personal reading assurance": "Kişisel yorum güvencesi",
    "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
      "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
      "Deckaura yorumcusu, geleneksel tarot sembolizmini kullanarak yorumunuzu sorunuz, bağlamınız ve kartlarınızdan elle yazar. Yorum düşünmeye yardımcı olur; sonuçları garanti etmez veya özel düşünceleri ortaya çıkarmaz.",
  });
  Object.assign(EXTRA_UI.de, {
    "Retrying secure price check…":
      "Sichere Preisprüfung wird erneut versucht…",
    "Kostenloses Tarot-Reading": "Kostenlose Tarotlegung",
    "Checkout could not be prepared. Your reading is safe; please try again.":
      "Der Checkout konnte nicht sicher vorbereitet werden. Deine Deutung bleibt erhalten; versuche es erneut.",
    "Secure checkout did not open. Please try again; your reading is still here.":
      "Der sichere Checkout wurde nicht geöffnet. Versuche es erneut; deine Deutung ist weiterhin hier.",
    "Checkout did not open. Your reading is safe; please try again.":
      "Der Checkout wurde nicht geöffnet. Deine Deutung bleibt erhalten; versuche es erneut.",
    "Write your question first.": "Schreibe zuerst deine Frage.",
    "Your personalized reading options are ready.":
      "Deine persönlichen Deutungsoptionen sind bereit.",
    "Your cards are ready. Turn each card over.":
      "Deine Karten sind bereit. Decke jede Karte auf.",
    "All three cards are turned.": "Alle drei Karten sind aufgedeckt.",
    "Your free reading is ready.": "Deine kostenlose Deutung ist bereit.",
    "Edit your question, then continue without re-entering your focus or situation.":
      "Bearbeite deine Frage und fahre fort, ohne Fokus oder Situation erneut einzugeben.",
    "Keep it to one new-love pattern and one focused question.":
      "Bleibe bei einem Muster für neue Liebe und einer klaren Frage.",
    "Is the free Liebestarot-Lesung really free?":
      "Ist das kostenlose Liebestarot wirklich kostenlos?",
    "Three cards, instant result, no sign-up":
      "Drei Karten, sofortiges Ergebnis, keine Anmeldung",
    "Reading focus": "Deutungsfokus",
    "Relationship situation": "Beziehungssituation",
    "Question examples": "Beispielfragen",
    "Reading options": "Deutungsoptionen",
    "Personal reading assurance": "Sicherheit zur persönlichen Deutung",
    "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
      "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
      "Deine Deutung wird aus deiner Frage, deinem Kontext und deinen Karten mit traditioneller Tarot-Symbolik von Hand geschrieben. Sie dient der Reflexion und garantiert keine Ergebnisse oder Einblicke in private Gedanken.",
  });
  Object.assign(EXTRA_UI.es, {
    "Retrying secure price check…":
      "Reintentando la comprobación segura del precio…",
    "Checkout could not be prepared. Your reading is safe; please try again.":
      "No se pudo preparar el pago de forma segura. Tu lectura sigue guardada; inténtalo de nuevo.",
    "Secure checkout did not open. Please try again; your reading is still here.":
      "El pago seguro no se abrió. Inténtalo de nuevo; tu lectura sigue aquí.",
    "Checkout did not open. Your reading is safe; please try again.":
      "El pago no se abrió. Tu lectura sigue guardada; inténtalo de nuevo.",
    "Write your question first.": "Escribe primero tu pregunta.",
    "Your personalized reading options are ready.":
      "Tus opciones de lectura personal están listas.",
    "Your cards are ready. Turn each card over.":
      "Tus cartas están listas. Revela cada carta.",
    "All three cards are turned.": "Las tres cartas están reveladas.",
    "Your free reading is ready.": "Tu lectura gratuita está lista.",
    "Edit your question, then continue without re-entering your focus or situation.":
      "Edita tu pregunta y continúa sin volver a introducir el enfoque ni la situación.",
    "Keep it to one new-love pattern and one focused question.":
      "Céntrate en un patrón de nuevo amor y una sola pregunta.",
    "Is the free lectura de tarot del amor really free?":
      "¿La lectura de amor gratuita es realmente gratis?",
    "Three cards, instant result, no sign-up":
      "Tres cartas, resultado inmediato, sin registro",
    "Reading focus": "Enfoque de la lectura",
    "Relationship situation": "Situación de la relación",
    "Question examples": "Ejemplos de preguntas",
    "Reading options": "Opciones de lectura",
    "Personal reading assurance": "Garantía de la lectura personal",
    "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
      "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
      "En Deckaura usamos el simbolismo tradicional del tarot para escribir a mano tu interpretación a partir de tu pregunta, contexto y cartas. Ayuda a reflexionar; no garantiza resultados ni revela pensamientos privados.",
  });
  Object.assign(EXTRA_UI.pt, {
    "Retrying secure price check…": "A repetir a verificação segura do preço…",
    "Checkout could not be prepared. Your reading is safe; please try again.":
      "Não foi possível preparar o pagamento em segurança. A sua leitura está guardada; tente novamente.",
    "Secure checkout did not open. Please try again; your reading is still here.":
      "O pagamento seguro não abriu. Tente novamente; a sua leitura continua aqui.",
    "Checkout did not open. Your reading is safe; please try again.":
      "O pagamento não abriu. A sua leitura está guardada; tente novamente.",
    "Write your question first.": "Escreva primeiro a pergunta.",
    "Your personalized reading options are ready.":
      "As suas opções de leitura pessoal estão prontas.",
    "Your cards are ready. Turn each card over.":
      "As suas cartas estão prontas. Revele cada carta.",
    "All three cards are turned.": "As três cartas estão reveladas.",
    "Your free reading is ready.": "A sua leitura gratuita está pronta.",
    "Edit your question, then continue without re-entering your focus or situation.":
      "Edite a pergunta e continue sem voltar a introduzir o foco nem a situação.",
    "HOJE’s free three-card result has already been opened on this device. You can still take one useful symbolic cue from this question, or continue with a private personal reading.":
      "O resultado gratuito de três cartas de hoje já foi aberto neste dispositivo. Ainda pode retirar um sinal simbólico útil desta pergunta ou continuar com uma leitura pessoal privada.",
    "Your question, situation and tiragem stay connected—no generic restart.":
      "A pergunta, a situação e a tiragem permanecem ligadas; sem recomeço genérico.",
    "The two Swords cards do not make this connection emotionless; they show that both sides are trying to manage it through thought and self-protection. The Devil in the direction posição is the deciding card: the pull is still active, but so is the cycle that made closeness costly. Before you wait, test whether one calm boundary produces consistent action over the next seven days.":
      "As duas cartas de Espadas não tornam esta ligação sem emoção; mostram que ambos os lados tentam geri-la através do pensamento e da autoproteção. O Diabo na posição de direção é a carta decisiva: a atração continua ativa, mas também o ciclo que tornou a proximidade dispendiosa. Antes de esperar, teste se um limite calmo produz ações consistentes nos próximos sete dias.",
    "Keep it to one new-love pattern and one focused question.":
      "Concentre-se num padrão de novo amor e numa pergunta clara.",
    "No, and we will not claim it does. A reading works with symbols. The second card reflects how the other person’s visible energy, behaviour and role in the connection maio be understood symbolically.":
      "Não, e não fazemos essa afirmação. Uma leitura trabalha com símbolos. A segunda carta reflete como a energia visível, o comportamento e o papel da outra parte podem ser entendidos simbolicamente.",
    "No. Your focus, relationship status, question and three cards stay attached to your order, so the paid reading continues from the same tiragem.":
      "Não. O foco, a situação, a pergunta e as três cartas ficam anexados à encomenda; a leitura pessoal continua a mesma tiragem.",
    "No physical item ships. Every reading is digital and arrives by email; Shopify checkout maio still request billing details for payment verification.":
      "Não é enviado qualquer artigo físico. Todas as leituras são digitais e chegam por email; a Shopify pode pedir dados de faturação para verificar o pagamento.",
    "Three-card relationship tiragem":
      "Tiragem de relacionamento com três cartas",
    "1 free tiragem per 24 hours": "1 tiragem grátis a cada 24 horas",
    "HOJE’s free three-card opening is complete.":
      "A tiragem gratuita de três cartas de hoje está concluída.",
    "A fuller tiragem for complex situations":
      "Uma tiragem mais completa para situações complexas",
    "One card for HOJE": "Uma carta para hoje",
    "Three cards, instant result, no sign-up":
      "Três cartas, resultado imediato, sem registo",
    "Reading focus": "Foco da leitura",
    "Relationship situation": "Situação da relação",
    "Question examples": "Exemplos de perguntas",
    "Reading options": "Opções de leitura",
    "Personal reading assurance": "Garantia da leitura pessoal",
    "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.":
      "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.":
      "Na Deckaura, usamos o simbolismo tradicional do tarot para escrever à mão a sua interpretação a partir da sua pergunta, contexto e cartas. Apoia a reflexão; não garante resultados nem revela pensamentos privados.",
  });

  Object.assign(EXTRA_UI.tr, {
    Essential: "Temel",
    Focused: "Odaklı",
    "In-Depth": "Kapsamlı",
    "Anonymized example · Focused reading":
      "Anonimleştirilmiş örnek · Odaklı yorum",
  });
  Object.assign(EXTRA_UI.de, {
    Essential: "Basis",
    Focused: "Fokussiert",
    "In-Depth": "Ausführlich",
    "Anonymized example · Focused reading":
      "Anonymisiertes Beispiel · fokussierte Deutung",
  });
  Object.assign(EXTRA_UI.es, {
    Essential: "Esencial",
    Focused: "Enfocada",
    "In-Depth": "En profundidad",
    "Anonymized example · Focused reading":
      "Ejemplo anónimo · lectura Enfocada",
  });
  Object.assign(EXTRA_UI.pt, {
    Essential: "Essencial",
    Focused: "Focada",
    "In-Depth": "Aprofundada",
    "Anonymized example · Focused reading": "Exemplo anónimo · leitura Focada",
  });

  /* Active V2 funnel copy. Keeping these sentence-level translations together
     prevents fragments from reintroducing vague or unsupported fulfilment copy. */
  Object.assign(EXTRA_UI.tr, {
    "Question-first relationship spread":
      "Önce soruyla başlayan ilişki açılımı",
    "Ask the relationship question that is actually on your mind, then draw three cards for a concise symbolic reading.":
      "Aklınızdaki ilişki sorusunu sorun, ardından kısa bir sembolik yorum için üç kart çekin.",
    "Ask My Love Question": "Aşk Sorumu Sor",
    "Question first": "Önce soru",
    "Question first, three cards, instant result, no sign-up":
      "Önce soru, üç kart, anında sonuç, kayıt yok",
    "Ask your love question": "Aşk sorunuzu sorun",
    "Ask about one relationship, one person or a new-love pattern.":
      "Tek bir ilişkiyi, kişiyi veya yeni aşk örüntüsünü sorun.",
    "Use at least 8 characters. Open questions read more clearly than yes-or-no questions.":
      "En az 8 karakter kullanın. Açık uçlu sorular, evet-hayır sorularından daha net yorumlanır.",
    "Write at least 8 characters so the cards can be read for a specific question.":
      "Kartların belirli bir soruya göre yorumlanabilmesi için en az 8 karakter yazın.",
    "What these cards suggest": "Bu kartların gösterdiği",
    "The critical question still open": "Açık kalan kritik soru",
    "Built from your exact question and three cards · symbolic guidance, not a fixed prediction.":
      "Tam sorunuzdan ve üç kartınızdan oluşturuldu · sabit bir kehanet değil, sembolik rehberlik.",
    "Your exact question and three cards stay attached. Choose one one-time digital reading.":
      "Tam sorunuz ve üç kartınız bağlı kalır. Tek seferlik iki dijital yorumdan birini seçin.",
    "No restart: this same love reading continues through secure checkout.":
      "Baştan başlamazsınız: aynı aşk yorumu güvenli ödeme boyunca devam eder.",
    "Review the context attached to checkout":
      "Ödemeye bağlı bağlamı gözden geçirin",
    "Three cards reserved for this reading": "Bu yorum için ayrılan üç kart",
    "One-time digital purchase · no subscription · delivery by email and secure reading page after checkout.":
      "Tek seferlik dijital satın alma · abonelik yok · ödeme sonrasında e-posta ve güvenli yorum sayfasıyla teslimat.",
    "Digital reading · email + secure page after checkout":
      "Dijital yorum · ödeme sonrasında e-posta + güvenli sayfa",
    "Yes. One free three-card opening is available per 24 hours on this device. The cards, concise synthesis and critical open question cost nothing; no account or payment card is needed.":
      "Evet. Bu cihazda her 24 saatte bir ücretsiz üç kart açılımı kullanılabilir. Kartlar, kısa sentez ve açık kalan kritik soru ücretsizdir; hesap veya ödeme kartı gerekmez.",
    "Your free card-specific insight appears on this page immediately. If you buy, the selected digital reading is prepared from the exact question, situation and three cards attached at checkout, then delivered by email and a secure reading page. Delivery begins after successful payment.":
      "Kartlarınıza özgü ücretsiz içgörü bu sayfada hemen görünür. Satın alırsanız seçilen dijital yorum, ödemeye bağlı tam soru, durum ve üç karttan hazırlanıp e-posta ve güvenli yorum sayfasıyla teslim edilir. Hazırlık başarılı ödemeden sonra başlar.",
    "Yes. Ask about meeting someone new, your readiness for love or the pattern you want to change. The page frames the spread around your own next step instead of a specific person.":
      "Evet. Yeni biriyle tanışmayı, aşka hazır oluşunuzu veya değiştirmek istediğiniz örüntüyü sorun. Sayfa açılımı belirli bir kişi yerine kendi sonraki adımınız etrafında şekillendirir.",
  });
  Object.assign(EXTRA_UI.de, {
    "Question-first relationship spread":
      "Beziehungslegung mit der Frage zuerst",
    "Ask the relationship question that is actually on your mind, then draw three cards for a concise symbolic reading.":
      "Stelle die Beziehungsfrage, die dich wirklich beschäftigt, und ziehe dann drei Karten für eine kurze symbolische Deutung.",
    "Ask My Love Question": "Meine Liebesfrage stellen",
    "Question first": "Frage zuerst",
    "Question first, three cards, instant result, no sign-up":
      "Frage zuerst, drei Karten, sofortiges Ergebnis, keine Anmeldung",
    "Ask your love question": "Stelle deine Liebesfrage",
    "Ask about one relationship, one person or a new-love pattern.":
      "Frage nach einer Beziehung, einer Person oder einem Muster für eine neue Liebe.",
    "Use at least 8 characters. Open questions read more clearly than yes-or-no questions.":
      "Verwende mindestens 8 Zeichen. Offene Fragen lassen sich klarer deuten als Ja-Nein-Fragen.",
    "Write at least 8 characters so the cards can be read for a specific question.":
      "Schreibe mindestens 8 Zeichen, damit die Karten zu einer konkreten Frage gedeutet werden können.",
    "What these cards suggest": "Was diese Karten nahelegen",
    "The critical question still open": "Die entscheidende offene Frage",
    "Built from your exact question and three cards · symbolic guidance, not a fixed prediction.":
      "Aus deiner genauen Frage und drei Karten erstellt · symbolische Orientierung, keine feste Vorhersage.",
    "Your exact question and three cards stay attached. Choose one one-time digital reading.":
      "Deine genaue Frage und drei Karten bleiben verbunden. Wähle eine der beiden einmaligen digitalen Deutungen.",
    "No restart: this same love reading continues through secure checkout.":
      "Kein Neustart: Dieselbe Liebeslegung bleibt bis zum sicheren Checkout verbunden.",
    "Review the context attached to checkout":
      "Mit dem Checkout verbundenen Kontext prüfen",
    "Three cards reserved for this reading":
      "Drei für diese Deutung reservierte Karten",
    "One-time digital purchase · no subscription · delivery by email and secure reading page after checkout.":
      "Einmaliger digitaler Kauf · kein Abo · Lieferung nach dem Checkout per E-Mail und sicherer Deutungsseite.",
    "Digital reading · email + secure page after checkout":
      "Digitale Deutung · E-Mail + sichere Seite nach dem Checkout",
    "Yes. One free three-card opening is available per 24 hours on this device. The cards, concise synthesis and critical open question cost nothing; no account or payment card is needed.":
      "Ja. Auf diesem Gerät ist alle 24 Stunden eine kostenlose Drei-Karten-Legung verfügbar. Karten, kurze Synthese und entscheidende offene Frage sind kostenlos; Konto oder Zahlungskarte sind nicht nötig.",
    "Your free card-specific insight appears on this page immediately. If you buy, the selected digital reading is prepared from the exact question, situation and three cards attached at checkout, then delivered by email and a secure reading page. Delivery begins after successful payment.":
      "Dein kostenloser kartenspezifischer Einblick erscheint sofort. Beim Kauf wird die gewählte digitale Deutung aus der beim Checkout verbundenen Frage, Situation und den drei Karten erstellt und per E-Mail sowie sicherer Deutungsseite geliefert. Die Bearbeitung beginnt nach erfolgreicher Zahlung.",
    "Yes. Ask about meeting someone new, your readiness for love or the pattern you want to change. The page frames the spread around your own next step instead of a specific person.":
      "Ja. Frage danach, jemand Neues kennenzulernen, nach deiner Bereitschaft für Liebe oder nach einem Muster, das du verändern möchtest. Die Legung richtet sich dann nach deinem eigenen nächsten Schritt statt nach einer bestimmten Person.",
  });
  Object.assign(EXTRA_UI.es, {
    "Question-first relationship spread":
      "Tirada de relación que empieza por tu pregunta",
    "Ask the relationship question that is actually on your mind, then draw three cards for a concise symbolic reading.":
      "Haz la pregunta de relación que de verdad tienes en mente y después saca tres cartas para una lectura simbólica concisa.",
    "Ask My Love Question": "Hacer mi pregunta de amor",
    "Question first": "Primero la pregunta",
    "Question first, three cards, instant result, no sign-up":
      "Primero la pregunta, tres cartas, resultado inmediato, sin registro",
    "Ask your love question": "Haz tu pregunta de amor",
    "Ask about one relationship, one person or a new-love pattern.":
      "Pregunta por una relación, una persona o un patrón de amor nuevo.",
    "Use at least 8 characters. Open questions read more clearly than yes-or-no questions.":
      "Usa al menos 8 caracteres. Las preguntas abiertas se leen con más claridad que las de sí o no.",
    "Write at least 8 characters so the cards can be read for a specific question.":
      "Escribe al menos 8 caracteres para que las cartas puedan leerse para una pregunta concreta.",
    "What these cards suggest": "Lo que sugieren estas cartas",
    "The critical question still open": "La pregunta crítica que sigue abierta",
    "Built from your exact question and three cards · symbolic guidance, not a fixed prediction.":
      "Creada a partir de tu pregunta exacta y tres cartas · orientación simbólica, no una predicción fija.",
    "Your exact question and three cards stay attached. Choose one one-time digital reading.":
      "Tu pregunta exacta y tus tres cartas siguen vinculadas. Elige una de las dos lecturas digitales de pago único.",
    "No restart: this same love reading continues through secure checkout.":
      "Sin reiniciar: esta misma lectura de amor continúa durante el pago seguro.",
    "Review the context attached to checkout":
      "Revisar el contexto vinculado al pago",
    "Three cards reserved for this reading":
      "Tres cartas reservadas para esta lectura",
    "One-time digital purchase · no subscription · delivery by email and secure reading page after checkout.":
      "Compra digital de pago único · sin suscripción · entrega por email y página segura después del pago.",
    "Digital reading · email + secure page after checkout":
      "Lectura digital · email + página segura después del pago",
    "Yes. One free three-card opening is available per 24 hours on this device. The cards, concise synthesis and critical open question cost nothing; no account or payment card is needed.":
      "Sí. En este dispositivo hay una tirada gratuita de tres cartas cada 24 horas. Las cartas, la síntesis breve y la pregunta crítica abierta no cuestan nada; no necesitas cuenta ni tarjeta.",
    "Your free card-specific insight appears on this page immediately. If you buy, the selected digital reading is prepared from the exact question, situation and three cards attached at checkout, then delivered by email and a secure reading page. Delivery begins after successful payment.":
      "Tu orientación gratuita y específica para estas cartas aparece de inmediato. Si compras, la lectura digital elegida se prepara con la pregunta, la situación y las tres cartas vinculadas al pago, y se entrega por email y página segura. La preparación comienza tras el pago correcto.",
    "Yes. Ask about meeting someone new, your readiness for love or the pattern you want to change. The page frames the spread around your own next step instead of a specific person.":
      "Sí. Pregunta por conocer a alguien nuevo, tu disposición para el amor o el patrón que quieres cambiar. La página orienta la tirada hacia tu propio siguiente paso en lugar de una persona concreta.",
  });
  Object.assign(EXTRA_UI.pt, {
    "Question-first relationship spread":
      "Tiragem de relação que começa pela pergunta",
    "Ask the relationship question that is actually on your mind, then draw three cards for a concise symbolic reading.":
      "Faça a pergunta de relação que tem realmente em mente e depois tire três cartas para uma leitura simbólica concisa.",
    "Ask My Love Question": "Fazer a minha pergunta de amor",
    "Question first": "Primeiro a pergunta",
    "Question first, three cards, instant result, no sign-up":
      "Primeiro a pergunta, três cartas, resultado imediato, sem registo",
    "Ask your love question": "Faça a sua pergunta de amor",
    "Ask about one relationship, one person or a new-love pattern.":
      "Pergunte sobre uma relação, uma pessoa ou um padrão de amor novo.",
    "Use at least 8 characters. Open questions read more clearly than yes-or-no questions.":
      "Use pelo menos 8 caracteres. Perguntas abertas permitem uma leitura mais clara do que perguntas de sim ou não.",
    "Write at least 8 characters so the cards can be read for a specific question.":
      "Escreva pelo menos 8 caracteres para que as cartas possam ser lidas para uma pergunta concreta.",
    "What these cards suggest": "O que estas cartas sugerem",
    "The critical question still open":
      "A questão crítica que permanece em aberto",
    "Built from your exact question and three cards · symbolic guidance, not a fixed prediction.":
      "Criada a partir da sua pergunta exata e de três cartas · orientação simbólica, não uma previsão fixa.",
    "Your exact question and three cards stay attached. Choose one one-time digital reading.":
      "A sua pergunta exata e as três cartas continuam ligadas. Escolha uma das duas leituras digitais de compra única.",
    "No restart: this same love reading continues through secure checkout.":
      "Sem recomeçar: esta mesma leitura de amor continua durante o pagamento seguro.",
    "Review the context attached to checkout":
      "Rever o contexto ligado ao pagamento",
    "Three cards reserved for this reading":
      "Três cartas reservadas para esta leitura",
    "One-time digital purchase · no subscription · delivery by email and secure reading page after checkout.":
      "Compra digital única · sem subscrição · entrega por email e página segura depois do pagamento.",
    "Digital reading · email + secure page after checkout":
      "Leitura digital · email + página segura depois do pagamento",
    "Yes. One free three-card opening is available per 24 hours on this device. The cards, concise synthesis and critical open question cost nothing; no account or payment card is needed.":
      "Sim. Neste dispositivo está disponível uma tiragem gratuita de três cartas a cada 24 horas. As cartas, a síntese breve e a questão crítica aberta são gratuitas; não precisa de conta nem cartão.",
    "Your free card-specific insight appears on this page immediately. If you buy, the selected digital reading is prepared from the exact question, situation and three cards attached at checkout, then delivered by email and a secure reading page. Delivery begins after successful payment.":
      "A orientação gratuita e específica para estas cartas aparece de imediato. Se comprar, a leitura digital escolhida é preparada a partir da pergunta, situação e três cartas ligadas ao pagamento, e entregue por email e página segura. A preparação começa após o pagamento bem-sucedido.",
    "Yes. Ask about meeting someone new, your readiness for love or the pattern you want to change. The page frames the spread around your own next step instead of a specific person.":
      "Sim. Pergunte sobre conhecer alguém novo, a sua disponibilidade para o amor ou o padrão que quer mudar. A página orienta a tiragem para o seu próprio próximo passo em vez de uma pessoa específica.",
  });

  /* Shared free allowance used: the server served the standard card-meaning
     summary instead of an answer written for the question. */
  var ALLOWANCE_UI = {
    tr: {
      "Your free personalized answers for today are used up, so this summary uses the standard meanings of your three cards, not your exact question. A written reading can still continue from your question and these cards.":
        "Bugünkü ücretsiz kişisel yorum hakkınız doldu. Bu özet sorunuza göre değil, üç kartınızın genel anlamlarına göre hazırlandı. Yazılı yorum yine sorunuz ve bu kartlarla devam edebilir.",
      "Standard card meanings · symbolic guidance, not a fixed prediction.":
        "Kartların genel anlamları · sabit bir kehanet değil, sembolik rehberlik.",
      "Your cards are ready. Today’s free personalized answers are used up.":
        "Kartlarınız hazır. Bugünkü ücretsiz kişisel yorum hakkınız doldu.",
    },
    de: {
      "Your free personalized answers for today are used up, so this summary uses the standard meanings of your three cards, not your exact question. A written reading can still continue from your question and these cards.":
        "Deine kostenlosen persönlichen Antworten für heute sind aufgebraucht. Diese Zusammenfassung nutzt deshalb die allgemeinen Bedeutungen deiner drei Karten, nicht deine genaue Frage. Eine schriftliche Deutung kann weiterhin mit deiner Frage und diesen Karten fortgesetzt werden.",
      "Standard card meanings · symbolic guidance, not a fixed prediction.":
        "Allgemeine Kartenbedeutungen · symbolische Orientierung, keine feste Vorhersage.",
      "Your cards are ready. Today’s free personalized answers are used up.":
        "Deine Karten sind bereit. Die kostenlosen persönlichen Antworten für heute sind aufgebraucht.",
    },
    es: {
      "Your free personalized answers for today are used up, so this summary uses the standard meanings of your three cards, not your exact question. A written reading can still continue from your question and these cards.":
        "Ya usaste tus respuestas personalizadas gratuitas de hoy, así que este resumen usa los significados generales de tus tres cartas, no tu pregunta exacta. Una lectura escrita puede continuar con tu pregunta y estas cartas.",
      "Standard card meanings · symbolic guidance, not a fixed prediction.":
        "Significados generales de las cartas · orientación simbólica, no una predicción fija.",
      "Your cards are ready. Today’s free personalized answers are used up.":
        "Tus cartas están listas. Ya usaste las respuestas personalizadas gratuitas de hoy.",
    },
    pt: {
      "Your free personalized answers for today are used up, so this summary uses the standard meanings of your three cards, not your exact question. A written reading can still continue from your question and these cards.":
        "As respostas personalizadas gratuitas de hoje já foram usadas, por isso este resumo usa os significados gerais das suas três cartas e não a sua pergunta exata. Uma leitura escrita pode continuar a partir da sua pergunta e destas cartas.",
      "Standard card meanings · symbolic guidance, not a fixed prediction.":
        "Significados gerais das cartas · orientação simbólica, não uma previsão fixa.",
      "Your cards are ready. Today’s free personalized answers are used up.":
        "As suas cartas estão prontas. As respostas personalizadas gratuitas de hoje já foram usadas.",
    },
  };
  Object.keys(ALLOWANCE_UI).forEach(function (key) {
    EXTRA_UI[key] = Object.assign(EXTRA_UI[key] || {}, ALLOWANCE_UI[key]);
  });

  var SAFE_FULFILMENT = {
    en: {
      reader: "Private written reading",
      delivery:
        "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.",
    },
    tr: {
      reader: "Özel yazılı yorum",
      delivery:
        "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    },
    de: {
      reader: "Private schriftliche Deutung",
      delivery:
        "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    },
    es: {
      reader: "Lectura escrita privada",
      delivery:
        "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    },
    pt: {
      reader: "Leitura escrita privada",
      delivery:
        "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    },
  };
  function fulfilmentSafe(value) {
    var text = String(value == null ? "" : value);
    var safe = SAFE_FULFILMENT[lang] || SAFE_FULFILMENT.en;
    if (/selin/i.test(text)) return safe.reader;
    if (/(?:30|90)\s*(?:min(?:ute|uten|utos?)?|dakika)/i.test(text))
      return safe.delivery;
    return value;
  }

  var RECOVERY_UI = {
    "Loading your card deck…": [
      "Kart desteniz yükleniyor…",
      "Dein Kartendeck wird geladen…",
      "Cargando tu baraja…",
      "A carregar o seu baralho…",
    ],
    "The card deck could not be loaded. Your question is saved; please try again.":
      [
        "Kart destesi yüklenemedi. Sorunuz kayıtlı; lütfen yeniden deneyin.",
        "Das Kartendeck konnte nicht geladen werden. Deine Frage ist gespeichert; versuche es erneut.",
        "No se pudo cargar la baraja. Tu pregunta está guardada; inténtalo de nuevo.",
        "Não foi possível carregar o baralho. A sua pergunta está guardada; tente novamente.",
      ],
    "Retry loading cards": [
      "Kartları yeniden yükle",
      "Karten erneut laden",
      "Volver a cargar las cartas",
      "Voltar a carregar as cartas",
    ],
    "Preparing your personalized answer. Your three cards are ready.": [
      "Kişisel yanıtınız hazırlanıyor. Üç kartınız hazır.",
      "Deine persönliche Antwort wird vorbereitet. Deine drei Karten sind bereit.",
      "Preparando tu respuesta personal. Tus tres cartas están listas.",
      "A preparar a sua resposta pessoal. As suas três cartas estão prontas.",
    ],
    "The personalized answer could not be prepared. Your cards are safe; retry this same spread.":
      [
        "Kişisel yanıt hazırlanamadı. Kartlarınız korunuyor; aynı açılım için yeniden deneyin.",
        "Die persönliche Antwort konnte nicht vorbereitet werden. Deine Karten bleiben erhalten; versuche es mit derselben Legung erneut.",
        "No se pudo preparar la respuesta personal. Tus cartas están guardadas; vuelve a intentarlo con esta misma tirada.",
        "Não foi possível preparar a resposta pessoal. As suas cartas estão guardadas; tente novamente com esta mesma tiragem.",
      ],
    "Retry personalized answer": [
      "Kişisel yanıtı yeniden dene",
      "Persönliche Antwort erneut versuchen",
      "Reintentar la respuesta personal",
      "Tentar novamente a resposta pessoal",
    ],
    "Start over and clear this question? Your free-reading limit will not reset.":
      [
        "Baştan başlayıp bu soruyu silmek istiyor musunuz? Ücretsiz açılım sınırınız sıfırlanmaz.",
        "Neu beginnen und diese Frage löschen? Dein Limit für kostenlose Legungen wird nicht zurückgesetzt.",
        "¿Empezar de nuevo y borrar esta pregunta? Tu límite de tiradas gratuitas no se restablecerá.",
        "Começar de novo e apagar esta pergunta? O seu limite de tiragens gratuitas não será reposto.",
      ],
  };
  ["tr", "de", "es", "pt"].forEach(function (language, index) {
    Object.keys(RECOVERY_UI).forEach(function (key) {
      DATA[language].ui[key] = RECOVERY_UI[key][index];
    });
    DATA[language].statuses.unspecified = [
      [
        "Belirtilmedi",
        "Nicht angegeben",
        "Sin especificar",
        "Não especificado",
      ][index],
      [
        "İlişki durumu varsayılmaz",
        "Kein Beziehungsstatus angenommen",
        "No se presupone una situación sentimental",
        "Não se presume uma situação amorosa",
      ][index],
    ];
  });

  var serviceCopyAliases = {
  "en": {
    "The free result is intentionally a concise symbolic reflection. A personal continuation gives Selin room to connect your exact question, situation and three cards into the deciding condition, timing difference and practical next step—without claiming access to another person’s private thoughts.": "The free reading outlines the card pattern. An optional personalized written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.",
    "full reading usually within 30 min": "Written by hand · most within 90 min",
    "Prepared personally by Selin": "Private written reading",
    "First insight now; full, handwritten reading usually by email and secure page within 30 minutes.": "Written by hand · most within 90 min",
    "Your first insight is already on screen. The complete reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.",
    "Your first insight appears on this page immediately. The complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.",
    "Full reading usually within 30 min by email + secure page": "Written by hand · most within 90 min",
    "The free result gives you the card-specific pattern. A personal continuation gives Selin room to test the unresolved condition against your exact question, compare timing and turn it into a practical next step.": "The free reading outlines the card pattern. An optional personalized written reading uses the same question and cards to explore the deciding condition, different timing possibilities and practical next steps at your chosen depth.",
    "Prepared by Selin Aura": "Private written reading",
    "Read by Selin Aura — founder of Deckaura": "Private written reading",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact question and cards shown above.": "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts.",
    "About Selin →": "About Deckaura and the method →",
    "usually within 30 min; allow up to 90 min": "Written by hand · most within 90 min",
    "The paid reading is written by hand and usually delivered by email and secure page within 30 minutes; allow up to 90 minutes at busy times.": "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.",
    "Your free card-specific insight appears on this page immediately. If you buy, the complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.",
    "Your free insight is already on screen. The complete paid reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact focus and question above, then connects them to your reserved spread.": "Deckaura’s reader uses traditional tarot symbolism to write your interpretation by hand from your question, context and cards. This supports reflection and does not guarantee outcomes or reveal private thoughts."
  },
  "tr": {
    "The free result is intentionally a concise symbolic reflection. A personal continuation gives Selin room to connect your exact question, situation and three cards into the deciding condition, timing difference and practical next step—without claiming access to another person’s private thoughts.": "Ücretsiz yorum kartların örüntüsünü gösterir. İsteğe bağlı, kişisel yazılı yorum aynı soru ve kartlarla belirleyici koşulu, farklı zamanlama olasılıklarını ve seçtiğiniz kapsamda uygulanabilir sonraki adımları inceler.",
    "Ücretsiz sonuç bilinçli olarak kısa bir sembolik yansımadır. Kişisel devam yorumunda Selin, başka birinin özel düşüncelerine eriştiğini iddia etmeden, tam sorunuzu, durumunuzu ve üç kartınızı belirleyici koşul, zamanlama farkı ve uygulanabilir sonraki adımla birleştirir.": "Ücretsiz yorum kartların örüntüsünü gösterir. İsteğe bağlı, kişisel yazılı yorum aynı soru ve kartlarla belirleyici koşulu, farklı zamanlama olasılıklarını ve seçtiğiniz kapsamda uygulanabilir sonraki adımları inceler.",
    "full reading usually within 30 min": "Elle yazılır · çoğu 90 dakika içinde",
    "tam yorum genellikle 30 dakika içinde": "Elle yazılır · çoğu 90 dakika içinde",
    "Prepared personally by Selin": "Özel yazılı yorum",
    "Selin tarafından kişisel olarak hazırlanır": "Özel yazılı yorum",
    "First insight now; full, handwritten reading usually by email and secure page within 30 minutes.": "Elle yazılır · çoğu 90 dakika içinde",
    "Ekrandaki ücretsiz içgörüden sonra tam yorum elle yazılır ve genellikle 30 dakika içinde e-posta ve güvenli sayfayla gelir.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Your first insight is already on screen. The complete reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "İlk içgörünüz zaten ekranda. Tam yorum elle yazılır ve genellikle 30 dakika içinde gelir; yoğun zamanlarda 90 dakikaya kadar sürebilir.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Your first insight appears on this page immediately. The complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "İlk içgörünüz bu sayfada hemen görünür. Tam yorum sorunuzdan, durumunuzdan ve üç kartınızdan elle yazılır ve veritabanımızdaki astroloji ve tarot sistemleriyle analiz edilir; genellikle 30 dakika içinde e-posta ve güvenli yorum sayfasıyla teslim edilir. Yoğun zamanlarda 90 dakikaya kadar sürebilir.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Tam yorum e-posta + güvenli sayfayla genellikle 30 dakika içinde": "Elle yazılır · çoğu 90 dakika içinde",
    "Full reading usually within 30 min by email + secure page": "Elle yazılır · çoğu 90 dakika içinde",
    "The free result gives you the card-specific pattern. A personal continuation gives Selin room to test the unresolved condition against your exact question, compare timing and turn it into a practical next step.": "Ücretsiz yorum kartların örüntüsünü gösterir. İsteğe bağlı, kişisel yazılı yorum aynı soru ve kartlarla belirleyici koşulu, farklı zamanlama olasılıklarını ve seçtiğiniz kapsamda uygulanabilir sonraki adımları inceler.",
    "Ücretsiz sonuç kartlarınıza özgü örüntüyü verir. Kişisel devam yorumunda Selin, çözülmemiş koşulu tam sorunuza göre sınar, zamanlamayı karşılaştırır ve uygulanabilir bir sonraki adıma dönüştürür.": "Ücretsiz yorum kartların örüntüsünü gösterir. İsteğe bağlı, kişisel yazılı yorum aynı soru ve kartlarla belirleyici koşulu, farklı zamanlama olasılıklarını ve seçtiğiniz kapsamda uygulanabilir sonraki adımları inceler.",
    "Prepared by Selin Aura": "Özel yazılı yorum",
    "Selin Aura tarafından hazırlanır": "Özel yazılı yorum",
    "Read by Selin Aura — founder of Deckaura": "Özel yazılı yorum",
    "Selin Aura yorumlar — Deckaura kurucusu": "Özel yazılı yorum",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact question and cards shown above.": "Deckaura yorumcusu, geleneksel tarot sembolizmini kullanarak yorumunuzu sorunuz, bağlamınız ve kartlarınızdan elle yazar. Yorum düşünmeye yardımcı olur; sonuçları garanti etmez veya özel düşünceleri ortaya çıkarmaz.",
    "Tarot uygulayıcısı, spiritüel deste tasarımcısı ve The Beginner’s Journey to Tarot kitabının yazarı. Selin, yukarıdaki tam soru ve kartlardan devam eder.": "Deckaura yorumcusu, geleneksel tarot sembolizmini kullanarak yorumunuzu sorunuz, bağlamınız ve kartlarınızdan elle yazar. Yorum düşünmeye yardımcı olur; sonuçları garanti etmez veya özel düşünceleri ortaya çıkarmaz.",
    "About Selin →": "Deckaura ve yorum yöntemi hakkında →",
    "Selin hakkında →": "Deckaura ve yorum yöntemi hakkında →",
    "usually within 30 min; allow up to 90 min": "Elle yazılır · çoğu 90 dakika içinde",
    "genellikle 30 dakika içinde; 90 dakikaya kadar süre tanıyın": "Elle yazılır · çoğu 90 dakika içinde",
    "The paid reading is written by hand and usually delivered by email and secure page within 30 minutes; allow up to 90 minutes at busy times.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Ücretli yorum elle yazılır ve genellikle 30 dakika içinde e-posta ve güvenli sayfayla teslim edilir; yoğun zamanlarda 90 dakikaya kadar süre tanıyın.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Your free card-specific insight appears on this page immediately. If you buy, the complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Ücretsiz ve kartlarınıza özgü yorum bu sayfada hemen görünür. Satın alırsanız eksiksiz yorum sorunuz, durumunuz ve üç kartınızdan elle yazılır ve veritabanımızdaki astroloji ve tarot sistemleriyle analiz edilir; genellikle 30 dakika içinde e-posta ve güvenli okuma sayfasıyla teslim edilir. Yoğun zamanlarda 90 dakikaya kadar sürebilir.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Your free insight is already on screen. The complete paid reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Ücretsiz içgörünüz zaten ekranda. Eksiksiz ücretli yorum elle yazılır ve genellikle 30 dakika içinde gelir; yoğun zamanlarda 90 dakikaya kadar sürebilir.": "Yorumlar elle yazılır; çoğu 90 dakika içinde e-posta ve güvenli okuma sayfasına gelir. Yoğun günlerde 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact focus and question above, then connects them to your reserved spread.": "Deckaura yorumcusu, geleneksel tarot sembolizmini kullanarak yorumunuzu sorunuz, bağlamınız ve kartlarınızdan elle yazar. Yorum düşünmeye yardımcı olur; sonuçları garanti etmez veya özel düşünceleri ortaya çıkarmaz.",
    "Tarot uygulayıcısı, spiritüel deste tasarımcısı ve The Beginner’s Journey to Tarot kitabının yazarı. Selin yukarıdaki tam odak ve sorudan devam eder, ardından bunları size ayrılan açılımla birleştirir.": "Deckaura yorumcusu, geleneksel tarot sembolizmini kullanarak yorumunuzu sorunuz, bağlamınız ve kartlarınızdan elle yazar. Yorum düşünmeye yardımcı olur; sonuçları garanti etmez veya özel düşünceleri ortaya çıkarmaz."
  },
  "es": {
    "The free result is intentionally a concise symbolic reflection. A personal continuation gives Selin room to connect your exact question, situation and three cards into the deciding condition, timing difference and practical next step—without claiming access to another person’s private thoughts.": "La lectura gratuita describe el patrón de las cartas. Una lectura escrita opcional usa la misma pregunta y cartas para explorar la condición decisiva, posibles ritmos y próximos pasos prácticos con la profundidad elegida.",
    "full reading usually within 30 min": "Escrita a mano · la mayoría en 90 min",
    "Prepared personally by Selin": "Lectura escrita privada",
    "First insight now; full, handwritten reading usually by email and secure page within 30 minutes.": "Escrita a mano · la mayoría en 90 min",
    "Your first insight is already on screen. The complete reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Your first insight appears on this page immediately. The complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "El resultado gratuito es una reflexión simbólica breve a propósito. En la continuación personal, Selin conecta tu pregunta exacta, tu situación y tus tres cartas con la condición decisiva, el ritmo y el siguiente paso práctico, sin afirmar que accede a pensamientos privados.": "La lectura gratuita describe el patrón de las cartas. Una lectura escrita opcional usa la misma pregunta y cartas para explorar la condición decisiva, posibles ritmos y próximos pasos prácticos con la profundidad elegida.",
    "lectura completa normalmente en 30 min": "Escrita a mano · la mayoría en 90 min",
    "Preparada personalmente por Selin": "Lectura escrita privada",
    "Tras la orientación gratuita, la lectura completa se escribe a mano y suele llegar por email y página segura en 30 minutos.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Tu primera orientación ya está en pantalla. La lectura completa se escribe a mano y suele llegar en 30 minutos; en días de mucha demanda puede tardar hasta 90 minutos.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "La primera orientación aparece aquí al instante. La lectura completa y revisada se prepara con tu pregunta, situación y cartas, y suele entregarse por email y página segura en 30 minutos. Las revisiones excepcionales pueden tardar hasta 90 minutos.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Lectura completa normalmente en 30 minutos por email + página segura": "Escrita a mano · la mayoría en 90 min",
    "Full reading usually within 30 min by email + secure page": "Escrita a mano · la mayoría en 90 min",
    "The free result gives you the card-specific pattern. A personal continuation gives Selin room to test the unresolved condition against your exact question, compare timing and turn it into a practical next step.": "La lectura gratuita describe el patrón de las cartas. Una lectura escrita opcional usa la misma pregunta y cartas para explorar la condición decisiva, posibles ritmos y próximos pasos prácticos con la profundidad elegida.",
    "Prepared by Selin Aura": "Lectura escrita privada",
    "Read by Selin Aura — founder of Deckaura": "Lectura escrita privada",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact question and cards shown above.": "En Deckaura usamos el simbolismo tradicional del tarot para escribir a mano tu interpretación a partir de tu pregunta, contexto y cartas. Ayuda a reflexionar; no garantiza resultados ni revela pensamientos privados.",
    "About Selin →": "Sobre Deckaura y el método →",
    "usually within 30 min; allow up to 90 min": "Escrita a mano · la mayoría en 90 min",
    "The paid reading is written by hand and usually delivered by email and secure page within 30 minutes; allow up to 90 minutes at busy times.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Your free card-specific insight appears on this page immediately. If you buy, the complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "El resultado gratuito te da el patrón específico de tus cartas. En la continuación personal, Selin contrasta la condición sin resolver con tu pregunta exacta, compara el ritmo y la convierte en un siguiente paso práctico.": "La lectura gratuita describe el patrón de las cartas. Una lectura escrita opcional usa la misma pregunta y cartas para explorar la condición decisiva, posibles ritmos y próximos pasos prácticos con la profundidad elegida.",
    "Preparada por Selin Aura": "Lectura escrita privada",
    "Interpretada por Selin Aura — fundadora de Deckaura": "Lectura escrita privada",
    "Tarotista, diseñadora de barajas espirituales y autora de The Beginner’s Journey to Tarot. Selin continúa desde la pregunta exacta y las cartas mostradas arriba.": "En Deckaura usamos el simbolismo tradicional del tarot para escribir a mano tu interpretación a partir de tu pregunta, contexto y cartas. Ayuda a reflexionar; no garantiza resultados ni revela pensamientos privados.",
    "Sobre Selin →": "Sobre Deckaura y el método →",
    "normalmente en 30 min; permite hasta 90 min": "Escrita a mano · la mayoría en 90 min",
    "La lectura de pago suele entregarse por email y página segura en 30 minutos; permite hasta 90 minutos para revisiones adicionales.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Tu orientación gratuita y específica para estas cartas aparece de inmediato. Si compras, la lectura completa y revisada se prepara con tu pregunta, situación y tres cartas, y suele entregarse por email y página segura en 30 minutos. Las revisiones excepcionales pueden tardar hasta 90 minutos.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Your free insight is already on screen. The complete paid reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact focus and question above, then connects them to your reserved spread.": "En Deckaura usamos el simbolismo tradicional del tarot para escribir a mano tu interpretación a partir de tu pregunta, contexto y cartas. Ayuda a reflexionar; no garantiza resultados ni revela pensamientos privados.",
    "Tu orientación gratuita ya está en pantalla. La lectura completa de pago se escribe a mano y suele llegar en 30 minutos; en días de mucha demanda puede tardar hasta 90 minutos.": "Escritas a mano: la mayoría de las lecturas llegan por correo y a la página de lectura segura en 90 minutos. En días de mucha demanda pueden tardar hasta 24 horas. No hay envío físico.",
    "Tarotista, diseñadora de barajas espirituales y autora de The Beginner’s Journey to Tarot. Selin continúa desde el enfoque y la pregunta exactos de arriba y después los conecta con tu tirada reservada.": "En Deckaura usamos el simbolismo tradicional del tarot para escribir a mano tu interpretación a partir de tu pregunta, contexto y cartas. Ayuda a reflexionar; no garantiza resultados ni revela pensamientos privados."
  },
  "de": {
    "The free result is intentionally a concise symbolic reflection. A personal continuation gives Selin room to connect your exact question, situation and three cards into the deciding condition, timing difference and practical next step—without claiming access to another person’s private thoughts.": "Die kostenlose Deutung beschreibt das Kartenmuster. Eine optionale schriftliche Deutung nutzt dieselbe Frage und Karten, um die entscheidende Bedingung, mögliche Zeitverläufe und praktische nächste Schritte in der gewählten Tiefe zu erkunden.",
    "full reading usually within 30 min": "Von Hand geschrieben · meist in 90 Min.",
    "Prepared personally by Selin": "Private schriftliche Deutung",
    "First insight now; full, handwritten reading usually by email and secure page within 30 minutes.": "Von Hand geschrieben · meist in 90 Min.",
    "Your first insight is already on screen. The complete reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Your first insight appears on this page immediately. The complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Das kostenlose Ergebnis ist bewusst eine kurze symbolische Reflexion. In der persönlichen Fortsetzung verbindet Selin deine genaue Frage, Situation und drei Karten mit der entscheidenden Bedingung, dem Timing und einem praktischen nächsten Schritt, ohne private Gedanken anderer zu beanspruchen.": "Die kostenlose Deutung beschreibt das Kartenmuster. Eine optionale schriftliche Deutung nutzt dieselbe Frage und Karten, um die entscheidende Bedingung, mögliche Zeitverläufe und praktische nächste Schritte in der gewählten Tiefe zu erkunden.",
    "vollständige Deutung meist innerhalb von 30 Min.": "Von Hand geschrieben · meist in 90 Min.",
    "Persönlich von Selin erstellt": "Private schriftliche Deutung",
    "Nach dem kostenlosen Einblick kommt die vollständige, geprüfte Deutung meist innerhalb von 30 Minuten per E-Mail und sicherer Seite.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Dein erster Einblick ist bereits auf dem Bildschirm. Die vollständige Deutung wird von Hand geschrieben und kommt meist innerhalb von 30 Minuten; an vollen Tagen kann es bis zu 90 Minuten dauern.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Der erste Einblick erscheint sofort. Die vollständige Deutung wird aus Frage, Situation und Karten von Hand geschrieben und meist innerhalb von 30 Minuten per E-Mail und sicherer Seite geliefert. An vollen Tagen kann es bis zu 90 Minuten dauern.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Vollständige Deutung meist innerhalb von 30 Minuten per E-Mail + sicherer Seite": "Von Hand geschrieben · meist in 90 Min.",
    "Full reading usually within 30 min by email + secure page": "Von Hand geschrieben · meist in 90 Min.",
    "The free result gives you the card-specific pattern. A personal continuation gives Selin room to test the unresolved condition against your exact question, compare timing and turn it into a practical next step.": "Die kostenlose Deutung beschreibt das Kartenmuster. Eine optionale schriftliche Deutung nutzt dieselbe Frage und Karten, um die entscheidende Bedingung, mögliche Zeitverläufe und praktische nächste Schritte in der gewählten Tiefe zu erkunden.",
    "Prepared by Selin Aura": "Private schriftliche Deutung",
    "Read by Selin Aura — founder of Deckaura": "Private schriftliche Deutung",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact question and cards shown above.": "Deine Deutung wird aus deiner Frage, deinem Kontext und deinen Karten mit traditioneller Tarot-Symbolik von Hand geschrieben. Sie dient der Reflexion und garantiert keine Ergebnisse oder Einblicke in private Gedanken.",
    "About Selin →": "Über Deckaura und die Methode →",
    "usually within 30 min; allow up to 90 min": "Von Hand geschrieben · meist in 90 Min.",
    "The paid reading is written by hand and usually delivered by email and secure page within 30 minutes; allow up to 90 minutes at busy times.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Your free card-specific insight appears on this page immediately. If you buy, the complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Das kostenlose Ergebnis zeigt das kartenspezifische Muster. In der persönlichen Fortsetzung prüft Selin die ungelöste Bedingung an deiner genauen Frage, vergleicht das Timing und leitet einen praktischen nächsten Schritt ab.": "Die kostenlose Deutung beschreibt das Kartenmuster. Eine optionale schriftliche Deutung nutzt dieselbe Frage und Karten, um die entscheidende Bedingung, mögliche Zeitverläufe und praktische nächste Schritte in der gewählten Tiefe zu erkunden.",
    "Von Selin Aura erstellt": "Private schriftliche Deutung",
    "Gedeutet von Selin Aura — Gründerin von Deckaura": "Private schriftliche Deutung",
    "Tarotpraktikerin, spirituelle Kartendesignerin und Autorin von The Beginner’s Journey to Tarot. Selin setzt bei der genauen Frage und den oben gezeigten Karten an.": "Deine Deutung wird aus deiner Frage, deinem Kontext und deinen Karten mit traditioneller Tarot-Symbolik von Hand geschrieben. Sie dient der Reflexion und garantiert keine Ergebnisse oder Einblicke in private Gedanken.",
    "Über Selin →": "Über Deckaura und die Methode →",
    "meist innerhalb von 30 Min.; bis zu 90 Min. einplanen": "Von Hand geschrieben · meist in 90 Min.",
    "Die bezahlte Deutung kommt meist innerhalb von 30 Minuten per E-Mail und sicherer Seite; für zusätzliche Prüfungen bitte bis zu 90 Minuten einplanen.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Dein kostenloser, kartenspezifischer Einblick erscheint sofort auf dieser Seite. Beim Kauf wird die vollständige Deutung aus Frage, Situation und drei Karten von Hand geschrieben, mit den Astrologie- und Tarot-Systemen unserer Datenbank analysiert und meist innerhalb von 30 Minuten per E-Mail und sicherer Seite geliefert. An vollen Tagen kann es bis zu 90 Minuten dauern.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Your free insight is already on screen. The complete paid reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact focus and question above, then connects them to your reserved spread.": "Deine Deutung wird aus deiner Frage, deinem Kontext und deinen Karten mit traditioneller Tarot-Symbolik von Hand geschrieben. Sie dient der Reflexion und garantiert keine Ergebnisse oder Einblicke in private Gedanken.",
    "Dein kostenloser Einblick ist bereits auf dem Bildschirm. Die vollständige bezahlte Deutung wird von Hand geschrieben und kommt meist innerhalb von 30 Minuten; an vollen Tagen kann es bis zu 90 Minuten dauern.": "Von Hand geschrieben: Die meisten Deutungen kommen innerhalb von 90 Minuten per E-Mail und auf der sicheren Deutungsseite an. An vollen Tagen kann es bis zu 24 Stunden dauern. Es wird nichts versendet.",
    "Tarotpraktikerin, spirituelle Kartendesignerin und Autorin von The Beginner’s Journey to Tarot. Selin setzt beim genauen Fokus und der Frage oben an und verbindet beides anschließend mit deiner reservierten Legung.": "Deine Deutung wird aus deiner Frage, deinem Kontext und deinen Karten mit traditioneller Tarot-Symbolik von Hand geschrieben. Sie dient der Reflexion und garantiert keine Ergebnisse oder Einblicke in private Gedanken."
  },
  "pt": {
    "The free result is intentionally a concise symbolic reflection. A personal continuation gives Selin room to connect your exact question, situation and three cards into the deciding condition, timing difference and practical next step—without claiming access to another person’s private thoughts.": "A leitura gratuita descreve o padrão das cartas. Uma leitura escrita opcional usa a mesma pergunta e cartas para explorar a condição decisiva, diferentes possibilidades de ritmo e próximos passos práticos na profundidade escolhida.",
    "full reading usually within 30 min": "Escrita à mão · a maioria em 90 min",
    "Prepared personally by Selin": "Leitura escrita privada",
    "First insight now; full, handwritten reading usually by email and secure page within 30 minutes.": "Escrita à mão · a maioria em 90 min",
    "Your first insight is already on screen. The complete reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Your first insight appears on this page immediately. The complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "O resultado gratuito é, de propósito, uma reflexão simbólica breve. Na continuação pessoal, Selin liga a sua pergunta exata, situação e três cartas à condição decisiva, ao ritmo e ao passo prático seguinte, sem afirmar acesso a pensamentos privados.": "A leitura gratuita descreve o padrão das cartas. Uma leitura escrita opcional usa a mesma pergunta e cartas para explorar a condição decisiva, diferentes possibilidades de ritmo e próximos passos práticos na profundidade escolhida.",
    "leitura completa geralmente em 30 min": "Escrita à mão · a maioria em 90 min",
    "Preparada pessoalmente por Selin": "Leitura escrita privada",
    "Após a orientação gratuita, a leitura completa e verificada costuma chegar por email e página segura em 30 minutos.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "A primeira orientação já está no ecrã. A leitura completa costuma chegar em 30 minutos; verificações adicionais pouco frequentes podem demorar até 90 minutos.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "A primeira orientação aparece aqui de imediato. A leitura completa e verificada é preparada com a pergunta, a situação e as cartas, e costuma ser entregue por email e página segura em 30 minutos. Verificações excecionais podem demorar até 90 minutos.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Leitura completa geralmente em 30 minutos por email + página segura": "Escrita à mão · a maioria em 90 min",
    "Full reading usually within 30 min by email + secure page": "Escrita à mão · a maioria em 90 min",
    "The free result gives you the card-specific pattern. A personal continuation gives Selin room to test the unresolved condition against your exact question, compare timing and turn it into a practical next step.": "A leitura gratuita descreve o padrão das cartas. Uma leitura escrita opcional usa a mesma pergunta e cartas para explorar a condição decisiva, diferentes possibilidades de ritmo e próximos passos práticos na profundidade escolhida.",
    "Prepared by Selin Aura": "Leitura escrita privada",
    "Read by Selin Aura — founder of Deckaura": "Leitura escrita privada",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact question and cards shown above.": "Na Deckaura, usamos o simbolismo tradicional do tarot para escrever à mão a sua interpretação a partir da sua pergunta, contexto e cartas. Apoia a reflexão; não garante resultados nem revela pensamentos privados.",
    "About Selin →": "Sobre a Deckaura e o método →",
    "usually within 30 min; allow up to 90 min": "Escrita à mão · a maioria em 90 min",
    "The paid reading is written by hand and usually delivered by email and secure page within 30 minutes; allow up to 90 minutes at busy times.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Your free card-specific insight appears on this page immediately. If you buy, the complete reading is written by hand from your question, situation and three cards, analyzed with the astrology and tarot systems in our database, then usually delivered by email and secure reading page within 30 minutes. At busy times it can take up to 90 minutes.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "O resultado gratuito dá-lhe o padrão específico das cartas. Na continuação pessoal, Selin testa a condição por resolver em relação à sua pergunta exata, compara o ritmo e transforma-a num próximo passo prático.": "A leitura gratuita descreve o padrão das cartas. Uma leitura escrita opcional usa a mesma pergunta e cartas para explorar a condição decisiva, diferentes possibilidades de ritmo e próximos passos práticos na profundidade escolhida.",
    "Interpretada por Selin Aura — fundadora da Deckaura": "Leitura escrita privada",
    "Taróloga, designer de baralhos espirituais e autora de The Beginner’s Journey to Tarot. Selin continua a partir da pergunta exata e das cartas mostradas acima.": "Na Deckaura, usamos o simbolismo tradicional do tarot para escrever à mão a sua interpretação a partir da sua pergunta, contexto e cartas. Apoia a reflexão; não garante resultados nem revela pensamentos privados.",
    "geralmente em 30 min; permita até 90 min": "Escrita à mão · a maioria em 90 min",
    "A leitura paga costuma ser entregue por email e página segura em 30 minutos; permita até 90 minutos para verificações adicionais.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "A orientação gratuita e específica para estas cartas aparece de imediato nesta página. Se comprar, a leitura completa e verificada é preparada a partir da pergunta, situação e três cartas, e costuma chegar por email e página segura em 30 minutos. Verificações excecionais podem demorar até 90 minutos.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Your free insight is already on screen. The complete paid reading is written by hand and usually arrives within 30 minutes; at busy times it can take up to 90 minutes.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Tarot practitioner, spiritual deck designer and author of The Beginner’s Journey to Tarot. Selin continues from the exact focus and question above, then connects them to your reserved spread.": "Na Deckaura, usamos o simbolismo tradicional do tarot para escrever à mão a sua interpretação a partir da sua pergunta, contexto e cartas. Apoia a reflexão; não garante resultados nem revela pensamentos privados.",
    "A orientação gratuita já está no ecrã. A leitura paga completa costuma chegar em 30 minutos; verificações adicionais pouco frequentes podem demorar até 90 minutos.": "Escritas à mão: a maioria das leituras chega por e-mail e à página de leitura segura em 90 minutos. Em dias de maior procura pode demorar até 24 horas. Não há envio físico.",
    "Taróloga, designer de baralhos espirituais e autora de The Beginner’s Journey to Tarot. Selin continua a partir do foco e da pergunta exatos acima e depois liga-os à tiragem reservada.": "Na Deckaura, usamos o simbolismo tradicional do tarot para escrever à mão a sua interpretação a partir da sua pergunta, contexto e cartas. Apoia a reflexão; não garante resultados nem revela pensamentos privados."
  }
};
  Object.keys(serviceCopyAliases).forEach(function (code) {
    Object.assign(EXTRA_UI[code] || (EXTRA_UI[code] = {}), serviceCopyAliases[code]);
    if (DATA[code] && DATA[code].ui) Object.assign(DATA[code].ui, serviceCopyAliases[code]);
  });

  var paidOnlyCopy = {
    tr: {
      "Your free three-card opening is already used.": "Ücretsiz üç kart açılımınızı zaten kullandınız.",
      "You can still choose an optional paid reading for a new question.": "Yeni bir soru için isteğe bağlı ücretli yorum seçebilirsiniz.",
      "No account is needed. Your question stays attached to this reading.": "Hesap gerekmez. Sorunuz bu yoruma bağlı kalır.",
      "Your question is used to prepare your reading. It is not displayed publicly.": "Sorunuz yorumunuzu hazırlamak için kullanılır. Herkese açık gösterilmez.",
      "Your free opening is already used. This single symbolic cue is not another free three-card reading.": "Ücretsiz açılımınızı zaten kullandınız. Bu tek sembolik işaret, ikinci bir ücretsiz üç kart yorumu değildir.",
      "A symbolic cue": "Sembolik bir işaret",
      "Your question stays attached to this optional paid reading.": "Sorunuz bu isteğe bağlı ücretli yoruma bağlı kalır.",
      "Choose an optional one-time digital reading for your exact question and three cards.": "Tam sorunuz ve üç kartınız için tek seferlik ödeme ile isteğe bağlı dijital yorum seçin.",
      "Choose an optional one-time digital reading for your new question and three reserved cards.": "Yeni sorunuz ve ayrılmış üç kart için tek seferlik ödeme ile isteğe bağlı dijital yorum seçin.",
      "Your new question continues into the selected paid reading.": "Yeni sorunuz seçtiğiniz ücretli yoruma aktarılır.",
      "A love tarot reading offers symbolic reflection, not verified facts or a guaranteed prediction. Compare its suggestions with what you can observe in real life.": "Aşk tarotu doğrulanmış olgular veya garantili bir öngörü değil, sembolik bir değerlendirme sunar. Önerilerini gerçek hayatta gözlemleyebildiklerinizle karşılaştırın."
    },
    de: {
      "Your free three-card opening is already used.": "Deine kostenlose Drei-Karten-Legung wurde bereits genutzt.",
      "You can still choose an optional paid reading for a new question.": "Für eine neue Frage kannst du eine optionale kostenpflichtige Deutung wählen.",
      "No account is needed. Your question stays attached to this reading.": "Ein Konto ist nicht nötig. Deine Frage bleibt mit dieser Deutung verbunden.",
      "Your question is used to prepare your reading. It is not displayed publicly.": "Deine Frage wird zur Vorbereitung deiner Deutung verwendet. Sie wird nicht öffentlich angezeigt.",
      "Your free opening is already used. This single symbolic cue is not another free three-card reading.": "Deine kostenlose Legung wurde bereits genutzt. Dieser einzelne symbolische Hinweis ist keine weitere kostenlose Drei-Karten-Deutung.",
      "A symbolic cue": "Ein symbolischer Hinweis",
      "Your question stays attached to this optional paid reading.": "Deine Frage bleibt mit dieser optionalen kostenpflichtigen Deutung verbunden.",
      "Choose an optional one-time digital reading for your exact question and three cards.": "Wähle eine optionale digitale Deutung mit einmaliger Zahlung für deine genaue Frage und drei Karten.",
      "Choose an optional one-time digital reading for your new question and three reserved cards.": "Wähle eine optionale digitale Deutung mit einmaliger Zahlung für deine neue Frage und drei reservierte Karten.",
      "Your new question continues into the selected paid reading.": "Deine neue Frage wird in die gewählte kostenpflichtige Deutung übernommen.",
      "A love tarot reading offers symbolic reflection, not verified facts or a guaranteed prediction. Compare its suggestions with what you can observe in real life.": "Eine Liebestarot-Deutung bietet symbolische Reflexion, keine überprüften Fakten oder garantierte Vorhersage. Vergleiche ihre Anregungen mit dem, was du im Alltag beobachten kannst."
    },
    es: {
      "Your free three-card opening is already used.": "Ya has utilizado tu tirada gratuita de tres cartas.",
      "You can still choose an optional paid reading for a new question.": "Puedes elegir una lectura opcional de pago para una nueva pregunta.",
      "No account is needed. Your question stays attached to this reading.": "No necesitas una cuenta. Tu pregunta permanece vinculada a esta lectura.",
      "Your question is used to prepare your reading. It is not displayed publicly.": "Tu pregunta se utiliza para preparar tu lectura. No se muestra públicamente.",
      "Your free opening is already used. This single symbolic cue is not another free three-card reading.": "Ya has utilizado tu tirada gratuita. Esta única señal simbólica no es otra lectura gratuita de tres cartas.",
      "A symbolic cue": "Una señal simbólica",
      "Your question stays attached to this optional paid reading.": "Tu pregunta permanece vinculada a esta lectura opcional de pago.",
      "Choose an optional one-time digital reading for your exact question and three cards.": "Elige una lectura digital opcional de pago único para tu pregunta exacta y tus tres cartas.",
      "Choose an optional one-time digital reading for your new question and three reserved cards.": "Elige una lectura digital opcional de pago único para tu nueva pregunta y tres cartas reservadas.",
      "Your new question continues into the selected paid reading.": "Tu nueva pregunta se conserva en la lectura de pago que elijas.",
      "A love tarot reading offers symbolic reflection, not verified facts or a guaranteed prediction. Compare its suggestions with what you can observe in real life.": "Una lectura de tarot del amor ofrece una reflexión simbólica, no hechos verificados ni una predicción garantizada. Compara sus sugerencias con lo que puedes observar en la vida real."
    },
    pt: {
      "Your free three-card opening is already used.": "A sua tiragem gratuita de três cartas já foi utilizada.",
      "You can still choose an optional paid reading for a new question.": "Pode escolher uma leitura paga opcional para uma nova pergunta.",
      "No account is needed. Your question stays attached to this reading.": "Não é necessária uma conta. A sua pergunta permanece ligada a esta leitura.",
      "Your question is used to prepare your reading. It is not displayed publicly.": "A sua pergunta é utilizada para preparar a leitura. Não é apresentada publicamente.",
      "Your free opening is already used. This single symbolic cue is not another free three-card reading.": "A sua tiragem gratuita já foi utilizada. Esta única pista simbólica não é outra leitura gratuita de três cartas.",
      "A symbolic cue": "Uma pista simbólica",
      "Your question stays attached to this optional paid reading.": "A sua pergunta permanece ligada a esta leitura paga opcional.",
      "Choose an optional one-time digital reading for your exact question and three cards.": "Escolha uma leitura digital opcional com pagamento único para a sua pergunta exata e três cartas.",
      "Choose an optional one-time digital reading for your new question and three reserved cards.": "Escolha uma leitura digital opcional com pagamento único para a sua nova pergunta e três cartas reservadas.",
      "Your new question continues into the selected paid reading.": "A sua nova pergunta passa para a leitura paga escolhida.",
      "A love tarot reading offers symbolic reflection, not verified facts or a guaranteed prediction. Compare its suggestions with what you can observe in real life.": "Uma leitura de tarot do amor oferece uma reflexão simbólica, não factos verificados nem uma previsão garantida. Compare as sugestões com o que pode observar na vida real."
    }
  };
  Object.keys(paidOnlyCopy).forEach(function (code) {
    Object.assign(DATA[code].ui, paidOnlyCopy[code]);
  });


  /* Shared package meanings; internal tier tokens and verified market quotes stay unchanged. */
  var OFFER_COPY = {
  "en": {
    "names": [
      "Quick Clarity",
      "Focused Reading",
      "In-Depth Reading"
    ],
    "summaries": [
      "A direct answer and one practical next step.",
      "Connect the full spread to the pattern and your next actions.",
      "Compare two paths, risks and a practical 30-day plan."
    ],
    "features": [
      [
        "Direct response to your exact question",
        "The strongest signal and deciding condition",
        "One grounded next step"
      ],
      [
        "Every supplied card connected to your question",
        "The pattern, tension and condition to verify",
        "Three practical next actions"
      ],
      [
        "Alternative paths and trade-offs compared",
        "Risks, boundaries and safeguards",
        "A practical 30-day plan"
      ]
    ],
    "select": "Select this reading",
    "selected": "Selected reading",
    "continue": "Continue to secure checkout",
    "words": "words"
  },
  "tr": {
    "names": [
      "Kısa ve net yorum",
      "Odaklı yorum",
      "Derinlemesine yorum"
    ],
    "summaries": [
      "Doğrudan yanıt ve uygulanabilir bir sonraki adım.",
      "Tüm açılımı örüntüye ve atacağınız adımlara bağlar.",
      "İki yolu, riskleri ve uygulanabilir 30 günlük planı karşılaştırır."
    ],
    "features": [
      [
        "Tam sorunuza doğrudan yanıt",
        "En güçlü işaret ve belirleyici koşul",
        "Uygulanabilir bir sonraki adım"
      ],
      [
        "Paylaştığınız her kart sorunuzla ilişkilendirilir",
        "Örüntü, gerilim ve doğrulanacak koşul",
        "Atabileceğiniz üç somut adım"
      ],
      [
        "Alternatif yollar ve sonuçları karşılaştırılır",
        "Riskler, sınırlar ve koruyucu adımlar",
        "Uygulanabilir 30 günlük plan"
      ]
    ],
    "select": "Bu yorumu seç",
    "selected": "Seçilen yorum",
    "continue": "Güvenli ödemeye devam et",
    "words": "kelime"
  },
  "de": {
    "names": [
      "Schnelle Klarheit",
      "Fokussierte Deutung",
      "Ausführliche Deutung"
    ],
    "summaries": [
      "Eine direkte Antwort und ein konkreter nächster Schritt.",
      "Verbindet die ganze Legung mit dem Muster und deinen nächsten Schritten.",
      "Vergleicht zwei Wege, Risiken und einen praktischen 30-Tage-Plan."
    ],
    "features": [
      [
        "Direkte Antwort auf deine genaue Frage",
        "Stärkstes Signal und entscheidende Bedingung",
        "Ein konkreter nächster Schritt"
      ],
      [
        "Jede angegebene Karte mit deiner Frage verbunden",
        "Muster, Spannung und zu prüfende Bedingung",
        "Drei konkrete nächste Schritte"
      ],
      [
        "Alternative Wege und Zielkonflikte verglichen",
        "Risiken, Grenzen und Schutzmaßnahmen",
        "Ein praktischer 30-Tage-Plan"
      ]
    ],
    "select": "Diese Deutung wählen",
    "selected": "Gewählte Deutung",
    "continue": "Zum sicheren Checkout",
    "words": "Wörter"
  },
  "es": {
    "names": [
      "Claridad rápida",
      "Lectura enfocada",
      "Lectura en profundidad"
    ],
    "summaries": [
      "Una respuesta directa y un próximo paso práctico.",
      "Conecta toda la tirada con el patrón y tus siguientes acciones.",
      "Compara dos caminos, riesgos y un plan práctico de 30 días."
    ],
    "features": [
      [
        "Respuesta directa a tu pregunta exacta",
        "La señal principal y la condición decisiva",
        "Un próximo paso concreto"
      ],
      [
        "Cada carta aportada conectada con tu pregunta",
        "El patrón, la tensión y la condición que verificar",
        "Tres siguientes acciones prácticas"
      ],
      [
        "Comparación de caminos y compensaciones",
        "Riesgos, límites y protecciones",
        "Un plan práctico de 30 días"
      ]
    ],
    "select": "Elegir esta lectura",
    "selected": "Lectura elegida",
    "continue": "Continuar al pago seguro",
    "words": "palabras"
  },
  "fr": {
    "names": [
      "Clarté rapide",
      "Lecture ciblée",
      "Lecture approfondie"
    ],
    "summaries": [
      "Une réponse directe et une prochaine étape concrète.",
      "Relie tout le tirage au schéma et à vos prochaines actions.",
      "Compare deux chemins, les risques et un plan pratique sur 30 jours."
    ],
    "features": [
      [
        "Une réponse directe à votre question précise",
        "Le signal principal et la condition décisive",
        "Une prochaine étape concrète"
      ],
      [
        "Chaque carte fournie reliée à votre question",
        "Le schéma, la tension et la condition à vérifier",
        "Trois prochaines actions concrètes"
      ],
      [
        "Comparaison des chemins et compromis",
        "Les risques, les limites et les précautions",
        "Un plan pratique sur 30 jours"
      ]
    ],
    "select": "Choisir cette lecture",
    "selected": "Lecture choisie",
    "continue": "Continuer vers le paiement sécurisé",
    "words": "mots"
  },
  "pt": {
    "names": [
      "Clareza rápida",
      "Leitura focada",
      "Leitura aprofundada"
    ],
    "summaries": [
      "Uma resposta direta e um próximo passo prático.",
      "Relaciona toda a tiragem com o padrão e as suas próximas ações.",
      "Compara dois caminhos, riscos e um plano prático de 30 dias."
    ],
    "features": [
      [
        "Resposta direta à sua pergunta exata",
        "O sinal mais forte e a condição decisiva",
        "Um próximo passo concreto"
      ],
      [
        "Cada carta fornecida relacionada com a sua pergunta",
        "O padrão, a tensão e a condição a verificar",
        "Três próximas ações práticas"
      ],
      [
        "Comparação de caminhos e compromissos",
        "Riscos, limites e medidas de proteção",
        "Um plano prático de 30 dias"
      ]
    ],
    "select": "Escolher esta leitura",
    "selected": "Leitura escolhida",
    "continue": "Continuar para o pagamento seguro",
    "words": "palavras"
  },
  "ptbr": {
    "names": [
      "Clareza rápida",
      "Leitura focada",
      "Leitura aprofundada"
    ],
    "summaries": [
      "Uma resposta direta e um próximo passo prático.",
      "Conecta toda a tiragem ao padrão e às suas próximas ações.",
      "Compara dois caminhos, riscos e um plano prático de 30 dias."
    ],
    "features": [
      [
        "Resposta direta à sua pergunta exata",
        "O sinal mais forte e a condição decisiva",
        "Um próximo passo concreto"
      ],
      [
        "Cada carta fornecida conectada à sua pergunta",
        "O padrão, a tensão e a condição a verificar",
        "Três próximas ações práticas"
      ],
      [
        "Comparação de caminhos e escolhas",
        "Riscos, limites e medidas de proteção",
        "Um plano prático de 30 dias"
      ]
    ],
    "select": "Escolher esta leitura",
    "selected": "Leitura escolhida",
    "continue": "Continuar para o pagamento seguro",
    "words": "palavras"
  }
};
  var offerLocale = String(document.documentElement.lang || 'en').toLowerCase();
  var offerLanguage = offerLocale.indexOf('pt-br') === 0 ? 'ptbr' : offerLocale.split('-')[0];
  var offerCopy = OFFER_COPY[offerLanguage] || OFFER_COPY.en;
  /* Thousands separators follow each locale and match compare_length_written in that locale's file. */
  var OFFER_WORD_RANGES = {
    en: ['450–600', '750–950', '1,250–1,500'],
    tr: ['450–600', '750–950', '1.250–1.500'],
    de: ['450–600', '750–950', '1.250–1.500'],
    es: ['450–600', '750–950', '1.250–1.500'],
    ptbr: ['450–600', '750–950', '1.250–1.500'],
    pt: ['450–600', '750–950', '1250–1500'],
    fr: ['450–600', '750–950', '1\u00a0250–1\u00a0500']
  };
  function offerTier(index) {
    var number = Math.max(0, Math.min(2, Number(index) || 0));
    return { base: offerCopy.names[number], tag: offerCopy.names[number], badge: offerCopy.names[number], promise: offerCopy.summaries[number], bullets: offerCopy.features[number].slice(), cta: offerCopy.continue, words: (OFFER_WORD_RANGES[offerLanguage] || OFFER_WORD_RANGES.en)[number] + ' ' + offerCopy.words };
  }
  function offerText(key) { return offerCopy[key] || OFFER_COPY.en[key] || key; }

  function current() {
    return DATA[lang] || null;
  }
  function exact(value) {
    if (value === 'What this includes') return ({en:'What this includes',tr:'Yorumun içeriği',de:'Was enthalten ist',es:'Qué incluye',fr:'Ce qui est inclus',pt:'O que inclui',ptbr:'O que inclui'})[offerLanguage] || 'What this includes';
    var packageIndex = ['Quick Clarity','Focused Reading','In-Depth Reading'].indexOf(value);
    if (packageIndex >= 0) return offerCopy.names[packageIndex];
    var d = current();
    var extra = EXTRA_UI[lang] || {};
    return fulfilmentSafe(
      d && d.ui[value] ? d.ui[value] : extra[value] || value,
    );
  }
  function topic(key, index, fallback) {
    var d = current();
    return d && d.topics[key]
      ? d.topics[key][index]
      : EN_TOPICS[key]
        ? EN_TOPICS[key][index]
        : fallback;
  }
  function status(key, index, fallback) {
    var d = current();
    return d && d.statuses[key]
      ? d.statuses[key][index]
      : EN_STATUSES[key]
        ? EN_STATUSES[key][index]
        : fallback;
  }
  function tier(index, isSingle) {
    var source = isSingle
      ? SINGLE_TIER_DATA[lang] || SINGLE_TIER_DATA.en
      : TIER_DATA[lang] || TIER_DATA.en;
    return source[index] || TIER_DATA.en[index];
  }
  function string(key, vars) {
    var d = current();
    var value =
      d && d.strings[key] !== undefined ? d.strings[key] : EN_STRINGS[key];
    if (typeof value !== "string") return value;
    Object.keys(vars || {}).forEach(function (name) {
      value = value.replace("{" + name + "}", String(vars[name]));
    });
    return fulfilmentSafe(value);
  }
  function cardName(value) {
    if (lang === "en") return value;
    var majorIndex = MAJOR_EN.indexOf(value);
    if (majorIndex >= 0) return MAJOR[lang][majorIndex] || value;
    var match =
      /^(Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King) of (Wands|Cups|Swords|Pentacles)$/.exec(
        value,
      );
    if (!match || !MINOR[lang]) return value;
    return MINOR[lang].join(
      MINOR[lang].ranks[match[1]],
      MINOR[lang].suits[match[2]],
    );
  }
  function cardSig(value, fallback) {
    var match =
      /^(Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King) of (Wands|Cups|Swords|Pentacles)$/.exec(
        value,
      );
    if (!match) return fallback;
    if (lang === "en") return match[2] + " · " + match[1];
    var m = MINOR[lang];
    return m.suits[match[2]] + " · " + m.ranks[match[1]];
  }
  function profile(value) {
    var ending =
      /^(Death|The Tower|Ten of Swords|Eight of Cups|Five of Cups)$/.test(
        value,
      );
    var caution =
      /^(The Devil|The Moon|The Hanged Man|The Hermit|Three of Swords|Five of Swords|Seven of Swords|Eight of Swords|Nine of Swords|Four of Cups|Five of Pentacles|Seven of Cups|Nine of Wands|Ten of Wands)$/.test(
        value,
      );
    var opening =
      /^(The Lovers|The Star|The Sun|The World|The Empress|Temperance|Strength|The Chariot|Wheel of Fortune|Ace of Cups|Two of Cups|Ten of Cups|Ace of Pentacles|Four of Wands|Six of Wands|Nine of Cups)$/.test(
        value,
      );
    return ending
      ? "ending"
      : caution
        ? "caution"
        : opening
          ? "opening"
          : "mixed";
  }
  function verdict(cardValue, isSingle) {
    var tone = profile(cardValue);
    var set = VERDICTS[lang] || VERDICTS.en;
    var key = isSingle
      ? "single" + tone.charAt(0).toUpperCase() + tone.slice(1)
      : tone;
    return set[key] || set.mixed;
  }
  var THEMES = {
    en: {
      opening: "support, openness and forward movement",
      mixed: "a real pull with one unresolved condition",
      caution: "friction or attachment that needs a clear boundary",
      ending: "closure and the need to stop repeating an old cycle",
      Wands: "action and chemistry",
      Cups: "emotion and reciprocity",
      Swords: "thought, truth and conflict",
      Pentacles: "consistency and practical effort",
      Major: "a larger turning point",
    },
    tr: {
      opening: "destek, açıklık ve ileri hareket",
      mixed: "gerçek bir çekimle birlikte çözülmemiş bir koşul",
      caution: "net bir sınır isteyen sürtüşme veya bağlılık",
      ending: "kapanış ve eski bir döngüyü tekrarlamama ihtiyacı",
      Wands: "eylem ve kimya",
      Cups: "duygu ve karşılıklılık",
      Swords: "düşünce, gerçek ve çatışma",
      Pentacles: "tutarlılık ve somut emek",
      Major: "daha büyük bir dönüm noktası",
    },
    de: {
      opening: "Unterstützung, Offenheit und Vorwärtsbewegung",
      mixed: "echte Anziehung mit einer ungelösten Bedingung",
      caution: "Reibung oder Bindung, die eine klare Grenze braucht",
      ending: "Abschluss und das Ende eines alten Kreislaufs",
      Wands: "Handlung und Chemie",
      Cups: "Gefühl und Gegenseitigkeit",
      Swords: "Denken, Wahrheit und Konflikt",
      Pentacles: "Beständigkeit und praktische Mühe",
      Major: "einen größeren Wendepunkt",
    },
    es: {
      opening: "apoyo, apertura y avance",
      mixed: "una atracción real con una condición sin resolver",
      caution: "fricción o apego que necesita un límite claro",
      ending: "cierre y la necesidad de no repetir un ciclo antiguo",
      Wands: "acción y química",
      Cups: "emoción y reciprocidad",
      Swords: "pensamiento, verdad y conflicto",
      Pentacles: "constancia y esfuerzo práctico",
      Major: "un punto de inflexión mayor",
    },
    pt: {
      opening: "apoio, abertura e avanço",
      mixed: "uma atração real com uma condição por resolver",
      caution: "fricção ou apego que exige um limite claro",
      ending: "encerramento e a necessidade de não repetir um ciclo antigo",
      Wands: "ação e química",
      Cups: "emoção e reciprocidade",
      Swords: "pensamento, verdade e conflito",
      Pentacles: "consistência e esforço prático",
      Major: "um ponto de viragem maior",
    },
  };
  function suit(value) {
    var m = / of (Wands|Cups|Swords|Pentacles)$/.exec(value);
    return m ? m[1] : "Major";
  }
  function keywords(value) {
    var th = THEMES[lang] || THEMES.en;
    return th[profile(value)] + " · " + th[suit(value)];
  }
  function reading(value, position) {
    var name = cardName(value),
      key = keywords(value);
    if (lang === "tr")
      return (
        name +
        ", bu pozisyonda " +
        key +
        " temasını vurgular. Bunu kesin bir sonuç değil, davranışta doğrulanacak bir işaret olarak okuyun."
      );
    if (lang === "de")
      return (
        name +
        " betont in dieser Position " +
        key +
        ". Lies das als ein Zeichen, das sich im Verhalten bestätigen muss, nicht als festes Ergebnis."
      );
    if (lang === "es")
      return (
        name +
        " destaca en esta posición " +
        key +
        ". Léelo como una señal que debe confirmarse en la conducta, no como un resultado fijo."
      );
    if (lang === "pt")
      return (
        name +
        " destaca nesta posição " +
        key +
        ". Leia-o como um sinal a confirmar no comportamento, não como um resultado fixo."
      );
    return (
      name +
      " emphasizes " +
      key +
      " in this position. Read it as a signal to verify in behaviour, not as a fixed outcome."
    );
  }
  function questionLens(topicKey, isSingle) {
    if (lang === "tr") {
      if (isSingle)
        return "Bu soru belirli bir kişinin özel düşüncelerinden çok, sizin hazır oluşunuza ve seçebileceğiniz ilişki örüntüsüne bakıyor.";
      if (topicKey === "feelings")
        return "Buradaki güvenilir ölçü, özel hislere dair bir iddia değil, görünür karşılıklılık ve tutarlı davranıştır.";
      if (topicKey === "reconcile")
        return "Belirleyici olan yalnızca hissin kalması değil, ayrılığa yol açan örüntünün gerçekten değişip değişmediğidir.";
      if (topicKey === "contact")
        return "Asıl işaret yalnızca iletişimin başlaması değil, sonrasında net, karşılıklı ve tutarlı hâle gelmesidir.";
      return "Bu açılım sözlerden çok tekrar eden davranışa ve kontrolünüzdeki koşula ağırlık verir.";
    }
    if (lang === "de") {
      if (isSingle)
        return "Diese Frage folgt deiner Bereitschaft und dem Beziehungsmuster, das du wählen kannst, nicht den privaten Gedanken einer bestimmten Person.";
      if (topicKey === "feelings")
        return "Der verlässliche Maßstab ist sichtbare Gegenseitigkeit und beständiges Verhalten, nicht eine Behauptung über private Gefühle.";
      if (topicKey === "reconcile")
        return "Entscheidend ist nicht nur, ob Gefühl geblieben ist, sondern ob sich das Muster hinter der Trennung tatsächlich verändert hat.";
      if (topicKey === "contact")
        return "Das wichtige Zeichen ist nicht nur neuer Kontakt, sondern ob Kommunikation danach klar, gegenseitig und beständig wird.";
      return "Diese Legung gewichtet wiederholtes Verhalten und die Bedingung in deiner Hand stärker als Worte.";
    }
    if (lang === "es") {
      if (isSingle)
        return "Esta pregunta sigue tu propia disposición y el patrón de relación que puedes elegir, no los pensamientos privados de una persona concreta.";
      if (topicKey === "feelings")
        return "La medida fiable es la reciprocidad visible y la conducta constante, no una afirmación sobre sentimientos privados.";
      if (topicKey === "reconcile")
        return "Lo decisivo no es solo que quede sentimiento, sino que el patrón que causó la separación haya cambiado de verdad.";
      if (topicKey === "contact")
        return "La señal importante no es solo que vuelva el contacto, sino que la comunicación se haga clara, recíproca y constante.";
      return "Esta tirada da más peso a la conducta repetida y a la condición bajo tu control que a las palabras.";
    }
    if (lang === "pt") {
      if (isSingle)
        return "Esta pergunta acompanha a sua disponibilidade e o padrão de relação que pode escolher, não os pensamentos privados de uma pessoa específica.";
      if (topicKey === "feelings")
        return "A medida fiável é a reciprocidade visível e o comportamento consistente, não uma afirmação sobre sentimentos privados.";
      if (topicKey === "reconcile")
        return "O decisivo não é apenas restar sentimento, mas o padrão que causou a separação ter mudado de facto.";
      if (topicKey === "contact")
        return "O sinal importante não é apenas o contacto recomeçar, mas a comunicação tornar-se clara, recíproca e consistente.";
      return "Esta tiragem dá mais peso ao comportamento repetido e à condição sob o seu controlo do que às palavras.";
    }
    if (isSingle)
      return "This question follows your readiness and the relationship pattern you can choose, not a specific person’s private thoughts.";
    if (topicKey === "feelings")
      return "The reliable measure here is visible reciprocity and consistent behaviour, not a claim about private feelings.";
    if (topicKey === "reconcile")
      return "The deciding issue is not only whether feeling remains, but whether the pattern behind the separation has actually changed.";
    if (topicKey === "contact")
      return "The meaningful signal is not contact alone, but whether communication becomes clear, reciprocal and consistent afterwards.";
    return "This spread gives repeated behaviour and the condition within your control more weight than words.";
  }
  function fallback(cards, positions, topicKey, isSingle) {
    var one = cardName(cards[0].name),
      two = cardName(cards[1].name),
      three = cardName(cards[2].name);
    var a = keywords(cards[0].name),
      b = keywords(cards[1].name),
      c = keywords(cards[2].name);
    if (lang === "tr")
      return {
        p1:
          questionLens(topicKey, isSingle) +
          " " +
          one +
          ", " +
          positions[0] +
          " pozisyonunda " +
          a +
          " getirirken " +
          two +
          ", " +
          positions[1] +
          " alanında " +
          b +
          " gösteriyor.",
        p2:
          three +
          ", " +
          positions[2] +
          " pozisyonunda açılımın dönüm noktasıdır: " +
          c +
          ". Açık kalan soru, bunun kısa bir evre mi yoksa sonraki bölümü belirleyecek örüntü mü olduğudur.",
      };
    if (lang === "de")
      return {
        p1:
          questionLens(topicKey, isSingle) +
          " " +
          one +
          " bringt in der Position " +
          positions[0] +
          " " +
          a +
          ", während " +
          two +
          " bei " +
          positions[1] +
          " " +
          b +
          " zeigt.",
        p2:
          three +
          " ist in der Position " +
          positions[2] +
          " der Wendepunkt der Legung: " +
          c +
          ". Offen bleibt, ob dies eine kurze Phase oder das Muster ist, das das nächste Kapitel entscheidet.",
      };
    if (lang === "es")
      return {
        p1:
          questionLens(topicKey, isSingle) +
          " " +
          one +
          " aporta en " +
          positions[0] +
          " " +
          a +
          ", mientras " +
          two +
          " muestra en " +
          positions[1] +
          " " +
          b +
          ".",
        p2:
          three +
          " es el punto de giro en " +
          positions[2] +
          ": " +
          c +
          ". La pregunta abierta es si se trata de una fase breve o del patrón que decidirá el siguiente capítulo.",
      };
    if (lang === "pt")
      return {
        p1:
          questionLens(topicKey, isSingle) +
          " " +
          one +
          " traz em " +
          positions[0] +
          " " +
          a +
          ", enquanto " +
          two +
          " mostra em " +
          positions[1] +
          " " +
          b +
          ".",
        p2:
          three +
          " é o ponto de viragem em " +
          positions[2] +
          ": " +
          c +
          ". A questão em aberto é se isto é uma fase breve ou o padrão que decidirá o próximo capítulo.",
      };
    return {
      p1:
        questionLens(topicKey, isSingle) +
        " In " +
        positions[0] +
        ", " +
        one +
        " brings " +
        a +
        ", while " +
        two +
        " shows " +
        b +
        " in " +
        positions[1] +
        ".",
      p2:
        three +
        " is the pivot in " +
        positions[2] +
        ": " +
        c +
        ". The open question is whether this is a short phase or the pattern that decides the next chapter.",
    };
  }
  function control(isSingle) {
    if (lang === "tr")
      return isSingle
        ? "Bir hafta boyunca yeni bir bağda aradığınız tek standardı koruyun ve yalnızca tutarlı biçimde karşılık veren kişilere alan açın."
        : "Gözlemleyebileceğiniz tek bir davranış ve yedi günlük makul bir süre belirleyin. Yoğun sözlerden çok sakin ve tutarlı takibe ağırlık verin.";
    if (lang === "de")
      return isSingle
        ? "Halte eine Woche lang einen wichtigen Maßstab für neue Verbindungen und gib nur Menschen Raum, die beständig darauf antworten."
        : "Lege ein beobachtbares Verhalten und ein realistisches Sieben-Tage-Fenster fest. Gewichte ruhige Beständigkeit stärker als intensive Worte.";
    if (lang === "es")
      return isSingle
        ? "Mantén durante una semana un criterio importante para una nueva conexión y abre espacio solo a quien responda con constancia."
        : "Define una conducta observable y un plazo razonable de siete días. Da más peso a la constancia tranquila que a las palabras intensas.";
    if (lang === "pt")
      return isSingle
        ? "Mantenha durante uma semana um critério importante para uma nova ligação e dê espaço apenas a quem responda com consistência."
        : "Defina um comportamento observável e um prazo razoável de sete dias. Dê mais peso à consistência tranquila do que a palavras intensas.";
    return isSingle
      ? "Hold one important standard for a new connection for the next week, and make room only for people who respond consistently."
      : "Choose one observable behaviour and a reasonable seven-day window. Give calm follow-through more weight than intense words.";
  }
  function openLine(cardValue, isSingle) {
    var name = cardName(cardValue);
    if (lang === "tr")
      return isSingle
        ? name +
            " yeni bir bağa hazır olduğunuzu gösteriyorsa, bunu hangi somut davranış doğrular?"
        : name +
            " bu bağın belirleyici kartıysa, ilişkinin yönünü hangi somut davranış değişikliği doğrular?";
    if (lang === "de")
      return isSingle
        ? "Wenn " +
            name +
            " deine Bereitschaft für eine neue Verbindung zeigt, welches konkrete Verhalten bestätigt sie?"
        : "Wenn " +
            name +
            " die entscheidende Karte dieser Verbindung ist, welche konkrete Verhaltensänderung bestätigt ihre Richtung?";
    if (lang === "es")
      return isSingle
        ? "Si " +
            name +
            " muestra tu disposición para un nuevo vínculo, ¿qué conducta concreta la confirmaría?"
        : "Si " +
            name +
            " es la carta decisiva de este vínculo, ¿qué cambio concreto de conducta confirmaría su dirección?";
    if (lang === "pt")
      return isSingle
        ? "Se " +
            name +
            " mostra a sua disponibilidade para uma nova ligação, que comportamento concreto a confirmaria?"
        : "Se " +
            name +
            " é a carta decisiva desta ligação, que mudança concreta de comportamento confirmaria a sua direção?";
    return isSingle
      ? "If " +
          name +
          " shows your readiness for a new connection, what specific behaviour would confirm it?"
      : "If " +
          name +
          " is the deciding card in this connection, what specific change in behaviour would confirm its direction?";
  }
  function localizeCardNames(value) {
    if (lang === "en") return value;
    var result = String(value || "");
    var names = MAJOR_EN.slice().sort(function (a, b) {
      return b.length - a.length;
    });
    names.forEach(function (name) {
      result = result.split(name).join(cardName(name));
    });
    result = result.replace(
      /\b(Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King) of (Wands|Cups|Swords|Pentacles)\b/g,
      function (name) {
        return cardName(name);
      },
    );
    return result;
  }
  function apply(scope) {
    if (lang === "en") return;
    var root = scope || document;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (
        !node.parentElement ||
        /^(SCRIPT|STYLE|TEXTAREA)$/.test(node.parentElement.tagName)
      )
        continue;
      var trimmed = node.nodeValue.trim();
      if (!trimmed) continue;
      var translated = exact(trimmed);
      if (translated !== trimmed)
        node.nodeValue = node.nodeValue.replace(trimmed, translated);
    }
    root.querySelectorAll("[aria-label],[title]").forEach(function (el) {
      ["aria-label", "title"].forEach(function (attr) {
        if (!el.hasAttribute(attr)) return;
        var value = el.getAttribute(attr);
        var translated = exact(value);
        if (translated !== value) el.setAttribute(attr, translated);
      });
    });
  }

  window.DeckauraLoveTarotI18n = {
    lang: lang,
    exact: exact,
    topic: topic,
    status: status,
    tier: tier,
    offerTier: offerTier,
    offerText: offerText,
    string: string,
    cardName: cardName,
    cardSig: cardSig,
    cardKeywords: keywords,
    cardReading: reading,
    localizeCardNames: localizeCardNames,
    profile: profile,
    verdict: verdict,
    questionLens: questionLens,
    fallback: fallback,
    control: control,
    openLine: openLine,
    apply: apply,
  };
})();
